<template>
<div class="flex-fill fill flex column ofy">

<div class="opt r">

    <input-field v-if="tab == 'Actual'" inputClass="secondary"
    v-model="search"
    placeholder="Buscar..."
    pre="search"
    cleareable
    :icon="mobile ? 'search' : ''"
    :timeout="200"
    useHeader>
    </input-field>

    <input-select v-model="orderBy" ref="orderBy" v-if="tab == 'Actual'" 
    class="ml5" inputClass="secondary"
    :items="orderByOptions"
    :icon="mobile ? 'sort' : ''">
    </input-select>

    <input-select v-model="orderSpace" v-if="tab == 'Actual'" 
    class="ml5" inputClass="secondary"
    :items="spaces"
    :icon="mobile ? 'filter' : ''">
    </input-select>
    
    <input-select 
    v-model="localFilterItemsWaste" 
    v-show="tab == 'Merma' && Local.type === 'FRANCHISE'"
    class="ml5" inputClass="secondary"
    :items="localsOptionsTransfer.map(item => ({ text: item.name, value: item.id })).concat({ text: 'Todos', value: null })"
    :icon="mobile ? 'filter' : ''">
    </input-select>

    <input-range inputClass="secondary"
    v-show="tab == 'Merma'"
    class="ml5"
    v-model="rangeWaste"
    :icon="mobile ? 'calendar' : ''"
    @OnValueChanged="tab == 'Merma' ? SearchItemsWaste() : null"
    >
    </input-range>
    
    <input-range inputClass="secondary"
    v-show="tab == 'Resumen'"
    class="ml5"
    v-model="range"
    :icon="mobile ? 'calendar' : ''"
    @OnValueChanged="tab == 'Resumen' ? Search() : null">
    </input-range>

    <input-field  v-if="tab == 'Proveedores'" class="ml5"
    v-model="searchProvider"
    placeholder="Buscar..."
    pre="search"
    clearable
    inputClass="secondary"
    :icon="mobile ? 'search' : ''"
    useHeader>
    </input-field>

    <input-field  v-if="tab == 'Historial'" class="mr5"
    v-model="searchRecord"
    placeholder="Buscar..."
    @OnChange="LoadHistory()"
    pre="search"
    clearable
    inputClass="secondary"
    :icon="mobile ? 'search' : ''"
    useHeader
    :timeout="1000"
    >
    </input-field>

    <input-select v-model="orderByRecord" ref="orderByHistorial" v-if="tab == 'Historial'" 
    class="mr5" inputClass="secondary"
    :items="orderByOptionsHistorial"
    :triggerFirstValueChanged="false"
    :icon="mobile ? 'sort' : ''"
    @OnValueChanged="LoadHistory()"
    >
    </input-select>

    <input-date :icon="mobile ? 'calendar' : null" 
        inputClass="secondary" 
        v-show="tab == 'Historial'"
        type="DATE"
        format="timestamp"
        v-model="dateFilter"
        :toEndDay="true"
        modalOnly
        @OnAcceptDate="LoadHistory()">
    </input-date>
    <i class="options icon-dots-vertical ml5" @click="Options([
        //{text: 'Reset Inventario', class: 'error-color', if: Auth.role.indexOf('admin') > -1, confirm: `¿Desea resetear el stock de inventario?`, function: () => {ResetStock()} },
        {text: 'Reset Inventario', class: 'error-color', if: Auth.role.indexOf('admin') > -1, function: () => {Options([
            {text: 'Reset Items', class: 'error-color', confirm: `¿Desea borrar TODOS los items de inventario?`, function: () => {ResetStock(true)}, icon: 'trash'},
            {text: 'Reset Stock', class: 'error-color', confirm: `¿Desea resetear el stock de inventario?`, function: () => {ResetStock()}, icon: 'square-trash'},
        ])}, icon: 'clean' },
        {text: 'Enviar a Merma', class: 'error-color', function: () => {ClickModalAddStockTransfer('AD', true)}, icon: 'square-trash'},
        {text: 'Imprimir', function: () => {Print()}, if: !!Local.modules.module_service, icon: 'printing'},
        {text: 'Ver Valor Disponible', class: 'selected-color', function: () => {ShowModalInventoryValueAvailable()}, if: Auth.role.indexOf('admin') > -1, icon: 'diamond'},
        {text: 'Exportar', function: () => {Export()}, if: Auth.role.indexOf('admin') > -1, icon: 'download'},
        {text: 'Importar', function: () => {ModalImportInventory = {}}, if: Auth.role.indexOf('admin') > -1, icon: 'upload'},
        //{text: 'Generar Inventario', if: Auth.role.indexOf('admin') > -1, function: () => {GenerateInventory()}},
        {text: 'Comparar Inventario', class: 'selected-color', function: () => {CompareAvailableStock()}, icon: 'comparation'},
        {text: 'Transferir Inventario', function: () => {ClickModalAddStockTransfer('TF')}, if: !!(localsOptionsTransfer && localsOptionsTransfer.length), icon: 'square-send'},
        {text: 'Agregar Inventario', function: () => {ClickModalAddStockTransfer('AD')}, icon: 'square-plus'},
        {text: 'Crear Item', class: 'selected-color', if: Auth.role.indexOf('admin') > -1, function: () => {modalNew={performance: 100, section: 'Otros', space: 'General', auto_quantity : true}; subItems = []}, icon: 'plus'},
    ])"
    v-show="tab=='Actual'"></i>

    <i class="options icon-dots-vertical ml5" v-if="Auth.role.indexOf('admin') > -1" @click="Options([
        {text: 'Exportar', class: 'selected-color', function: () => { ExportWaste() }, icon: 'download' },
    ])"
    v-show="tab=='Merma'"></i>

    <i class="options icon-dots-vertical ml5" v-if="canCreateProvider" @click="Options([
        {text: 'Exportar Proveedores', class: 'selected-color', function: () => {$refs.providerList.ExportProviders()}, icon: 'download'},
        {text: 'Crear Proveedor', class: 'selected-color', function: () => {$refs.providerList.modalProvider={has_rut:true}}, if: canCreateProvider, icon: 'plus'},
    ])"
    v-show="tab=='Proveedores'"></i>

    <i class="options icon-dots-vertical ml5" @click="Options([
        {text: 'Exportar', class: 'selected-color', function: () => { ExportResumen() }, if: Auth.role.indexOf('admin') > -1 , icon: 'download'},
    ])"
    v-show="tab=='Resumen'"></i>
</div>


<tabs :tabs="tabs" :keyByTab="true"  v-if="tabs"
:tabCount="tabCount"
tabCountOnSelectedOnly
v-model="tab"
@OnTabHistorial="LoadHistory()"
@OnTabResumen="Search()"
@OnTabProveedores="LoadProviders"
@OnTabMerma="SearchItemsWaste()">

<!-- <i class="icon icon-datetime show-mobile" slot="options Resumen" @click="$refs.menuSearch.Open()"></i> -->

<div slot="Actual" class="pa-body">
    <div class="secondary-text ta-center mt10" v-if="!currentInventory.length">No hay items</div>
    <div class="mb20" v-for="section in currentInventory" :key="section.title">
        <div class="bgbg mb20 f18 mb10 flex align-center">
            <div class="flex-fill">
                <div class="flex align-center">{{section.title}} <span class="counter">{{section.items.length}}</span></div>
            </div>
            <div class="options icon-dots-vertical" v-if="Auth.role.indexOf('admin') > -1" @click="Options([
                {text: 'Crear Item', class: 'selected-color', function: () => {{modalNew={performance: 100, section: section.title, space: orderSpace, auto_quantity : true, integer_quantity : 0}; subItems = []}}, icon: 'plus'},
            ])"></div>
        </div>
        <div class="secondary-text ta-center mt10" v-if="!section.items.length">No hay items</div>
        
        <div :class="`${item.quantity <= 0 ? 'cred' : ''} section selectable mb10`" 
        v-for="item in section.items"
        :key="item.title"
        @click="isAdmin ? ItemStats(item) : Options([
            {text: `Enviar ${item.title} a merma`, class: 'error-color'/* , if: (!item.subitems || item.subitems.length == 0) */, function: () => { OpenModalAdd('merma', item) }, if: !!Auth.restrictions.reduce_inventory, icon: 'square-trash'},
            {text: `Descontar Inventario de ${item.title}`/* , if: (!item.subitems || item.subitems.length == 0) */ ,class: 'error-color', function: () => {OpenModalAdd('discount', item)}, if: !!Auth.restrictions.reduce_inventory, icon: 'square-minus'},
            {text: `Transferir ${item.title}`, if: (item.quantity > 0 && (Local.type == 'FRANCHISE' || localsOptionsTransfer.length > 0 || spaces.length > 1) && !!Auth.restrictions.reduce_inventory && !!Auth.restrictions.create_inventory) , function: () => { OpenModalTransferItem(item) }, icon: 'square-send'},
            {text: `Agregar ${item.title}`, class: 'selected-color'/* ,  if: !item.subitems || item.subitems.length == 0 */, function: () => { OpenModalAdd('add', item) }, if: !!Auth.restrictions.create_inventory, icon: 'square-add'},
        ])">
            <div class="flex fill align-center">

                <avatar class="mr10"
                :imageIcon="item.title"
                defaultImageIcon="799"
                :color="ItemColor(item)">
                </avatar>

                <div class="flex-fill flex column">
                    <span class="bold">{{item.title}} <span class="tag" v-if="item.subitems && item.subitems.length > 0">{{mobile ? 'C' : 'Compuesto'}}</span></span>
                    <span class="secondary-text" v-if="(item.subitems && item.subitems.length > 0)"> 
                        Componentes:
                        <span v-for="(subitem, index) in item.subitems" :key="index">
                            {{ subitem.base != null && !item.auto_calculate_quantity ? `(${subitem.base})` : '' }}
                            {{
                            (index != item.subitems.length-1)
                                ? `${Util.Number(subitem.quantity)} ${subitem.title} • ` 
                                : `${Util.Number(subitem.quantity)} ${subitem.title}`
                            }}
                        </span> 
                    </span>
                </div>
                <div class="flex column" style="text-align: right">
                    <div v-tooltip="`Cantidad disponible con ${item.performance}% rendimiento aplicado`">
                        <span class="bold">{{
                            Util.Number(
                                item.integer_quantity && item.subitems ? 
                                Math.round(item.quantity * item.performance / 100) : 
                                item.quantity * item.performance / 100
                            )}}</span>
                        <span v-if="item.unit" class="secondary-text ml5">{{item.unit}}</span>
                    </div>
                    <div v-if="item.performance !== 100" v-tooltip="`Cantidad real disponible (sin rendimiento)`">
                        <span class="secondary-text">{{Util.Number(item.quantity)}}<span v-if="item.unit" class="secondary-text ml5">{{item.unit}}</span></span>
                    </div>
                </div>
                <!-- <div class="icon icon-arrow-right-o ml10 c4"></div> -->
                <i v-if="isAdmin" class="options icon-dots-vertical ml10" @click.stop="Options([
                    {text: 'Eliminar', class: 'error-color', function: () => {DeleteItem(item)}, confirm: `¿Eliminar ${item.title} del inventario?`, icon: 'trash'},
                    {text: 'Editar', function: () => { modalEdit={ title: item.title, title_replace : item.title, unit: item.unit, performance: item.performance ? item.performance : 100, unit_cost: item.unit_cost, section: item.section ? item.section : 'Otros', space: item.space ? item.space : 'General', auto_quantity : item.auto_calculate_quantity, integer_quantity : item.integer_quantity}; subItems= item.subitems? Util.Copy(item.subitems) : [] }, icon: 'edit'},
                    {text: `Enviar ${item.title} a Merma`, function: () => {OpenModalAdd('merma', item)}, icon: 'square-trash'},
                    {text: `Descontar Inventario de ${item.title}`, function: () => {OpenModalAdd('discount', item)}, icon: 'square-minus'},
                    //{text: `Transferir Compuestos`, if: (item.subitems && item.subitems.length > 0 && !item.auto_calculate_quantity) , function: () => { OpenModalTransferItem(item, true) }}, //opción quitada por peticion #568
                    {text: `Transferir ${item.title}`, if: (item.quantity > 0 && (localsOptionsTransfer.length > 0 || Local.type == 'FRANCHISE' || spaces.length > 1) ) , function: () => { OpenModalTransferItem(item) }, icon: 'square-send'},
                    // {text: `Transferir ${item.title}`, if: (item.quantity > 0 && (localsOptionsTransfer.length > 0 || spaces.length > 1) ) , function: () => { OpenModalTransferItem(item) }},
                    {text: `Agregar ${item.title}`, class: 'selected-color', function: () => { OpenModalAdd('add', item) }, icon: 'square-plus' },
                ])"></i>
            </div>
        </div>

    </div>


</div>
<div slot="Merma" class="pa-body">
    <div class="secondary-text ta-center mt10" v-if="!itemsWaste">No hay items en merma</div>
    <div class="mb20">

        <!--<div class="bgbg mb10 mt10 f18 mb10">Productos en merma</div>-->
        <div class="secondary-text ta-center mt10" v-if="itemsWaste && itemsWaste.count <= 0">No hay items</div>
        
        <div v-if="itemsWaste && itemsWaste.count > 0">
            <div class="hdvm mb20">
                <div>
                    <div class="section flex align-center h100">
                        <avatar icon="money" class="mr10" :color="Util.baseColors.red"></avatar>
                        <div class="bold flex-fill">Total</div>
                        <div class="f18">{{Util.Price(itemsWaste.total_money)}}</div>
                    </div>
                </div>

                <div>
                    <div class="section h100">
                        <div class="scroll-container" style="max-height: 150px">
                            <div class="secondary-text ta-center" v-if="!itemsWaste || itemsWaste.reasons.length == 0">No hay motivos</div>
                            <div v-for="(reason, index) in itemsWaste.reasons" :key="index" class="flex mb5">
                                <badge :count="reason.count" color="blue" class="mr10" :round="false"></badge>
                                <span>{{index}}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!--<div class="hdvm mb20">
                <div class="section h100">
                    <div class="secondary-text ta-center" v-if="!this.itemsWaste && this.itemsWaste.total_total_reasons <= 0">No hay razones o motivos</div>
                    <div v-for="(val, tag) in tags" :key="tag" class="flex mb5">
                        <badge :count="val" color="blue" class="mr10" :round="false"></badge>
                        <span>{{tag}}</span>
                    </div>
                </div>
            </div>-->


            <div class="section selectable mb10" 
            @click="modalItemWaste=item"
            v-for="item in itemsWaste.items"
            :key="item.data">
                <div class="flex fill align-center">

                    <avatar class="mr10"
                    :imageIcon="item.title"
                    defaultImageIcon="799"
                    color="#ff495b">
                    </avatar>

                    <div class="flex-fill bold">
                        <span class="flex bold">
                            <span class="cred">
                                <span class="bold">-{{Util.Number(item.count * item.performance / 100)}}</span>
                                <span v-if="item.unit" class="secondary-text ml5">{{item.unit}}</span>
                            </span> 
                            <span class="ml5">{{item.data}}</span>
                        </span>
                    </div>
                    <div class="flex column" style="text-align: right">
                        <div class="bold">{{Util.Price(item.total_money ? item.total_money : 0)}}</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div slot="Resumen" v-if="stats" class="pa-body">

    <div class="hdvm mb20">
        
        <div>
            <div class="section flex align-center">
                <avatar class="mr10"
                icon="money"
                :color="Util.baseColors.red">
                </avatar>
                <div class="flex-fill">
                    <div class="bold">Total</div>
                    <div class="secondary-text">Gastado</div>
                </div>
                <div class="f18 cred">{{Util.Price(stats.total_money)}}</div>
            </div>
        </div>

        <div>
            <div class="section flex align-center">
                <avatar class="mr10"
                icon="box"
                secondaryIcon="plus"
                :color="Util.baseColors.green">
                </avatar>
                <div class="flex-fill">
                    <div class="bold">Igresado</div>
                    <div class="secondary-text">Transacciones</div>
                </div>
                <div class="f18 cgreen">{{Util.Number(stats.transactions_added.length)}}</div>
            </div>
        </div>

        <div>
            <div class="section flex align-center">
                <avatar class="mr10"
                icon="box"
                secondaryIcon="minus"
                :color="Util.baseColors.red">
                </avatar>
                <div class="flex-fill">
                    <div class="bold">Utilizado</div>
                    <div class="secondary-text">Transacciones</div>
                </div>
                <div class="">
                    <div class="bold cred ta-right">{{Util.Number(stats.transactions_used.length)}} </div> 
                    <span class="secondary-text" v-tooltip="'Total valorizado'">({{ Util.Price(CalculateSumUsed(stats.items)) }})</span>
                </div>
            </div>
        </div>
    </div>

    
    
    <div class="">
        <div class="flex align-center mb20">
            <div class="f18 flex-fill">Items</div>
            <input-field
            inputClass="secondary"
            v-model="searchResumen"
            placeholder="Buscar..."
            pre="search"
            cleareable
            :icon="mobile ? 'search' : ''"
            :timeout="200">
            </input-field>
        </div>

        <div class="section selectable mb10"
        v-for="(item, index) in filteredItemResumen"
        :key="index"
        @click="ItemResumenHistory(item)">
            <div class="fill flex align-center">
                <avatar class="mr10"
                :imageIcon="item.data"
                defaultImageIcon="799"
                :color="parseFloat(item.from) < parseFloat(item.to) ? Util.baseColors.green : Util.baseColors.red">
                </avatar>
                <div :class="`flex flex-fill ${mobile ? 'column' : ''}`">
                    <div class="flex-fill flex column">
                        <div class="bold">{{item.data}}</div>
                        <div class="secondary-text"><span class="bold">Total gastado: </span>{{Util.Price(item.total_money)}}</div>
                        <div class="secondary-text"><span class="bold">Total ingresado: </span>{{Util.Number(parseFloat(item.total_added))}} <span class="secondary-text" v-if="inventory[item.data] && inventory[item.data].unit">{{inventory[item.data].unit}}</span></div>
                        <div class="secondary-text"><span class="bold">Total utilizado: </span>{{Util.Number(parseFloat(item.total_used))}} <span class="secondary-text" v-if="inventory[item.data] && inventory[item.data].unit">{{inventory[item.data].unit}} </span> <span v-tooltip="`Valorizado con costo unitario ${Util.Price(inventory[item.data].unit_cost)}`" class="secondary-text" v-if="inventory[item.data] && inventory[item.data].unit_cost && !(item.total_used === 0 || inventory[item.data].unit_cost === 0)">({{ Util.Price(item.total_used * inventory[item.data].unit_cost) }}) </span></div>
                    </div>
                    <div :class="`flex align-center ${parseFloat(item.from) < parseFloat(item.to) ? 'cgreen' : 'cred'}`" v-if="item.from != item.to">
                        <div><span class="bold">{{Util.Number(parseFloat(item.from))}}</span> <span class="secondary-text ml5" v-if="inventory[item.data] && inventory[item.data].unit">{{inventory[item.data].unit}}</span></div>
                        <i class="icon icon-arrow-right ml10 mr10 c4 secondary-text"></i>
                        <div><span class="bold">{{Util.Number(parseFloat(item.to))}}</span> <span class="secondary-text ml5" v-if="inventory[item.data] && inventory[item.data].unit">{{inventory[item.data].unit}}</span></div>
                    </div>
                </div>
            </div>
        </div>
        <div class="secondary-text ta-center mt10" v-if="!stats.items.length">No hay datos.</div>
    </div>
</div>

<vertical-content ref="verticalHistory" slot="Historial" @OnBottom="LoadHistory(true)" class="pa-body">
    <div class="" v-if="history.length > 0">
        <div class="section mb10 selectable"
        v-for="(transaction, index) in history"
        :key="index"
        @click="$refs.inventoryDetails.Open(transaction)">
            <div class="fill flex align-center">
                <avatar class="mr10"
                :imageIcon="transaction.item"
                defaultImageIcon="799"
                :color="transaction.quantity < 0 ? Util.baseColors.red : Util.baseColors.green">
                </avatar>
                <div class="flex-fill flex column">
                    <div :class="`bold ${transaction.quantity < 0 ? 'cred' : 'cgreen'}`">{{Util.Number(parseFloat(transaction.quantity), false, true)}} <span class="secondary-text thin" v-if="inventory[transaction.item] && inventory[transaction.item].unit">{{inventory[transaction.item].unit}}</span> {{transaction.item}}</div>
                    <div class="secondary-text" v-if="transaction.comment"><span class="bold">Comentario:</span> {{transaction.comment}}</div>
                    <!-- <div class="secondary-text">{{transaction.quantity_from}} <i class="icon icon-arrow-right"></i> {{transaction.quantity_to}}</div> -->
                    <!-- <div class="secondary-text" v-if="transaction.id_transaction">Utilizado en el pedido X</div> -->
                    <div class="secondary-text" v-if="transaction.custom_data.created_by"><span class="bold">Ingresado por:</span> {{transaction.custom_data.created_by}}</div>
                    <div class="secondary-text"><span class="bold">Fecha:</span> {{Util.Date(transaction.date, 'DD/MM/YYYY HH:mm')}}</div>
                    <div class="secondary-text cred" v-if="transaction.deleted_at"><span class="bold">Eliminado:</span> {{Util.Date(transaction.deleted_at, 'DD/MM/YYYY HH:mm')}} por {{transaction.custom_data.deleted_by}}</div>
                    <div class="secondary-text cyellow" v-if="!transaction.expense_turn" title="No se muestra en reportes de Turno"><span class="bold"><i class="icon icon-circle-exclamation mr5"></i> No contabilizado en turno</span></div>
                </div>
                <div class="flex column" style="text-align: right" v-if="transaction.money">
                    <div :class="transaction.deleted_at ? 'line-through' : 'bold'">{{Util.Price(transaction.money)}}</div>
                    <div class="secondary-text">{{Util.PayMethod(transaction.pay_method)}}</div>
                </div>
                <!--<i class="icon icon-arrow-right-o c4 ml10"></i>-->
                
            </div>
        </div>
    </div>
    <div v-else class="secondary-text mt10 ta-center">No hay datos.</div>
</vertical-content>

<provider-list
slot="Proveedores"
ref="providerList"
:payMethods="payMethods"
:inventory="inventory"
:search="searchProvider"
@UpdateInventory="UpdateInventory"
@LoadProviders="LoadProviders()"
></provider-list>

</tabs>

<!--
<side-menu ref="menuSearch" position="bottom" size="auto" @OnOpen="Util.PlaceElement($refs.range.$el, $refs.menuSearchParent)">
    <div class="side-menu" ref="menuSearchParent">
        <h4>Rango de tiempo</h4>
    </div>
</side-menu>
-->

<modal v-model="ModalImportInventory" :dir="['right', 'center']" :modalClass="['fill borderless', 'sm']" title="Importar inventario">
    <div class="section" v-if="ModalImportInventory">
        
        <div class="mb20 secondary-text ta-center">Seleccionar un archivo Excel con el formato de inventario.</div>

        <label class="mb10 restriction-option">
            <input type="radio" name="ingnore_inventory" value="IGNORE" v-model="inventoryOption"> <div>Agregar items nuevos<div class="secondary-text">Se crearan los items nuevos con cantidad 0</div></div><div class="radio"></div>
        </label>
        <label class="mb10 restriction-option">
            <input type="radio" name="add_inventory" value="ADD" v-model="inventoryOption"> <div>Sumar cantidades<div class="secondary-text">Se agregarán sólo los items nuevos con la cantidad definida y se agregará/reducirá stock de los items existentes en la cantidad ingresada</div></div> <div class="radio"></div>
        </label>
        <label class="restriction-option">
            <input type="radio" name="set_inventory" value="SET" v-model="inventoryOption"> <div>Replicar <div class="secondary-text">Se crearán los items nuevos con la cantidad definida y se cambiará la cantidad de los items existentes a la cantidad ingresada</div></div><div class="radio"></div>
        </label>
        
    </div> 
    
    <button-file v-if="ModalImportInventory" accept=".xlsx, .xls, .csv"
    :type="null" slot="actions"
    @FileSelected="$set(ModalImportInventory, 'file', $event)">
        <button class="secondary">{{ModalImportInventory.file ? ModalImportInventory.file.name : 'Seleccionar Archivo'}}</button>
    </button-file>
    <button slot="actions" class="primary purple" @click="ImportInventory()">Importar</button>
</modal>

<modal v-model="modalAdd" dir="right" :modalClass="['fill', 'md right h100']" :title="modalAdd? TitleProduct(modalAdd) : ''">
    <div class="section" v-if="modalAdd">
        <input-select v-if="providersItems && !modalAdd.waste && !modalAdd.inventory_discount" class="mb15"
        v-model="modalAdd.provider" 
        :items="providersItems" 
        label="Proveedor"
        canType="search">
        </input-select>

        <input-field 
        v-if="modalAdd && modalAdd.provider" 
        v-model="modalAdd.number"
        class="mb15"
        label="Folio"
        type="int+"
        placeholder="(Opcional)"
        ></input-field>

        <label class="mb15" v-if="modalAdd && modalAdd.provider && modalAdd.number" >
            <input type="checkbox" v-model="modalAdd.pending"> Pago pendiente <div class="checkmark"></div>
        </label>

        <input-field class="mb15"
        v-model="modalAdd.add"
        label="Cantidad"
        :suffix="` ${modalAdd.item.unit? modalAdd.item.unit : ''}`"
        type="float+"
        @OnChangeFocused="QuantityChanged($event, modalAdd)">
        </input-field>

        <label class="mb15" v-if="modalAdd.waste">
            <input type="checkbox" v-model="modalAdd.addCost"> Agregar costo (será ingresado como egreso) <div class="checkmark"></div>
        </label>

        <div class="hs mb15" v-show="!modalAdd.inventory_discount && (!modalAdd.waste || modalAdd.addCost)">
            <input-field 
            v-model="modalAdd.unit_cost"
            label="Costo Unitario"
            placeholder="(Opcional)"
            type="float"
            prefix="$"
            :readonly="Auth.role == 'cashier' && !Auth.restrictions.can_edit_cost_unit? true : false"
            @OnChangeFocused="UnitCostChanged($event, modalAdd)">
                <div class="append unshrink" slot="after" v-if="modalAdd.item.unit">pesos por {{modalAdd.item.unit}}</div>
            </input-field>

            <input-field
            v-model="modalAdd.cost"
            label="Costo Total"
            placeholder="(Opcional)"
            type="float"
            prefix="$"
            after=" "
            :readonly="Auth.role == 'cashier' && !Auth.restrictions.can_edit_cost_unit && !modalAdd.unit_cost? true : false"
            @OnChangeFocused="$event => CostChanged($event, modalAdd)">
                <i class="icon icon-cross selectable" v-tooltip="'Quitar'" 
                v-show="modalAdd.cost" slot="inner-after"
                @click="$set(modalAdd, 'cost', null);$set(modalAdd, Auth.role == 'cashier' && !Auth.restrictions.can_edit_cost_unit? 'add' : 'unit_cost', null)"></i>
            </input-field>
        </div>

        <input-select v-if="!modalAdd.waste && !modalAdd.inventory_discount && !modalAdd.pending" class="mb15"
        v-show="modalAdd.cost > 0 || modalAdd.unit_cost > 0"
        label="Método de Pago"
        v-model="modalAdd.pay_method"
        :items="payMethods"
        canType="search">
        </input-select>

        <input-field v-if="!modalAdd.waste && !modalAdd.inventory_discount" class="mb15"
        v-model="modalAdd.comment"
        label="Comentario"
        placeholder="(Opcional)">
        </input-field>

        <input-select v-if="modalAdd.waste" class="mb15"
        label="Motivo"
        v-model="modalAdd.comment"
        :items="reasonsWaste"
        :canType="true">
        </input-select>

        <!--<input-image v-model="modalAdd.image" label="Documento (Opcional)"></input-image>-->
        <input-files v-show="!modalAdd.inventory_discount" v-model="modalAdd.files" label="Documento (Opcional)"></input-files>

    </div>
    
    <div class="fill flex align-center" slot="actions" v-if="modalAdd">
        <label slot="actions" v-if="canExpenseTurn && modalAdd" style="flex: auto;" class="flex align-center">
            <input type="checkbox" v-model="modalAdd.expense_turn"> Contabilizar en turno<div class="checkmark"></div>
        </label>
        <div class="mr20 unshrink flex align-center">
            <div>{{ Util.Number(parseFloat(modalAdd.item.isSubItem ? modalAdd.item.base : modalAdd.item.quantity))}} <span v-if="modalAdd.item.unit" class="secondary-text">{{modalAdd.item.unit}}</span></div>
            <i v-if="modalAdd.add" class="icon icon-arrow-right ml10 mr10 c4"></i>
            <div v-if="modalAdd.add">{{Util.Number(parseFloat((modalAdd.item.isSubItem ? modalAdd.item.base : modalAdd.item.quantity) + (modalAdd.waste || modalAdd.inventory_discount ? -modalAdd.add : modalAdd.add)))}} <span v-if="modalAdd.item.unit" class="secondary-text">{{modalAdd.item.unit}}</span></div>
        </div>
    </div>

    <button slot="actions" v-if="modalAdd && modalAdd.add < 0 && !modalAdd.waste && !modalAdd.inventory_discount" @click="AddStock()" class="primary error-color">Quitar</button>
    <button slot="actions" v-else v-show="modalAdd && !modalAdd.waste && !modalAdd.inventory_discount" :disabled="modalAdd && !modalAdd.add"  @click="AddStock()" class="primary purple">Agregar</button>

    <button slot="actions" v-if="modalAdd && (modalAdd.waste || modalAdd.inventory_discount)" @click="AddStock(true)" class="primary error-color">{{ modalAdd.waste ? 'Enviar a Merma' : 'Descontar'}}</button>
</modal>

<modal v-model="modalNew" :dir="['right', 'right']" :modalClass="['fill borderless', 'md right h100']" :title="'Nuevo Item de Inventario'">
    <div class="section" v-if="modalNew">
        
        <input-field class="mb15"
        v-model="modalNew.title"
        label="Nombre Item">
        </input-field>


        <input-field class="mb15"
        v-model="modalNew.unit"
        label="Unidad de medida"
        placeholder="(Opcional)">
        </input-field>

        <input-field
        v-if="(subItems.length == 0)"
        class="mb15"
        v-model="modalNew.unit_cost"
        label="Costo Unitario"
        type="float+"
        prefix="$"
        placeholder="0">
        </input-field>

        <input-field 
        class="mb15" v-if="(subItems.length == 0)"
        v-model="modalNew.performance"
        label="Rendimiento %"
        type="float+"
        suffix="%"
        placeholder="Porcentaje rendimiento">
        </input-field>

        <input-select class="mb15" 
        v-model="modalNew.space" 
        :fillSearchWithSelected="false"
        canType 
        :items="spaces" 
        label="Espacio">
        </input-select>

        <input-select 
        class="mb15" 
        :fillSearchWithSelected="false"
        v-model="modalNew.section" 
        canType 
        :items="sections" 
        label="Sección">
        </input-select>

        <label class="mb15" v-if="subItems.length">
            <input type="checkbox" v-model="modalNew.auto_quantity"> Calcular cantidad automáticamente <div class="checkmark"></div>
        </label>
        
        <label class="mb15"  v-if="subItems.length">
            <input type="checkbox" v-model="modalNew.integer_quantity"> Mostrar cantidad como numero entero <div class="checkmark"></div>
        </label>
        
        <div class="flex align-center mb5">
            <div class="flex-fill">
                <div class="bold">Sub Items</div>
            </div>
            <div class="f18">
                <input-select class="ml5"
                inputClass="icon primary"
                v-model="modalNew.subitem"
                :triggerFirstValueChanged="false"
                @OnValueChanged="AddSubItem($event, false)"
                :items="itemsMenuSelect"
                :canType="true"
                v-tooltip="'Agregar Subítem'"
                icon="plus">
                </input-select>
            </div>
        </div>
        <div class="flex align-center mb10 well" v-for="(subItem, index) in subItems" :key="index">
            <input-field
            v-model="subItem.title"
            class="flex-fill mr5">
            </input-field>

            <input-field
            v-model="subItem.quantity"
            :placeholder="inventory[subItem.title]? `Cantidad (${inventory[subItem.title].unit})` : 'Cantidad'"
            type="float+"
            :suffix="` ${inventory[subItem.title]? inventory[subItem.title].unit : ''}`"
            class="flex-fill ml5">
            </input-field>

            <i class="options icon-trash ml10" @click.stop="subItems.splice(index, 1)"></i>
        </div>
        <div class="secondary-text ta-center" v-if="!subItems.length">No hay sub ítems</div>

    </div> 
    <button class="primary purple" slot="actions" @click="CreateInventoryItem()">Crear item</button>
</modal>

<modal v-model="modalEdit" :dir="['right', 'right']" :modalClass="['fill borderless', 'md right h100']" :title="modalEdit ? modalEdit.title : ''">
    <div class="section" v-if="modalEdit">
        <input-field class="mb15"
        v-model="modalEdit.title_replace"
        label="Nombre Item">
        </input-field>

        <input-field class="mb15"
        v-model="modalEdit.unit"
        label="Unidad de medida"
        placeholder="(Opcional)">
        </input-field>
        <input-field
        v-if="(subItems && subItems.length == 0)"
        class="mb15"
        v-model="modalEdit.unit_cost"
        label="Costo Unitario"
        type="float+"
        prefix="$"
        placeholder="0">
        </input-field>

        <input-field class="mb15"
        v-model="modalEdit.performance"
        v-if="(subItems.length == 0)"
        label="Rendimiento %"
        type="float+"
        suffix="%"
        placeholder="Porcentaje rendimiento">
        </input-field>

        <input-select class="mb15" v-model="modalEdit.space" :fillSearchWithSelected="false" canType :items="spaces" label="Espacio"></input-select>

        <input-select class="mb15" v-model="modalEdit.section" :fillSearchWithSelected="false" canType :items="sections" label="Sección"></input-select>

        <!--
        <div class="input-style" v-if="modalEdit.unit_cost">
            <div class="input-label">Precio Unitario</div>
            <div>${{Util.Number(modalEdit.unit_cost)}}</div>
        </div>
        -->

        <label class="mb15" v-if="subItems.length">
            <input type="checkbox" v-model="modalEdit.auto_quantity"> Calcular cantidad automáticamente <div class="checkmark"></div>
        </label>
        
        <label class="mb15" v-if="subItems.length">
            <input type="checkbox" v-model="modalEdit.integer_quantity"> Mostrar cantidad como numero entero <div class="checkmark"></div>
        </label>
        <div class="flex align-center mb5">
            <div class="flex-fill">
                <div class="bold">Sub Items</div>
            </div>
            <div class="f18">
                <input-select class="ml5"
                inputClass="icon primary"
                v-model="modalEdit.subitem"
                :triggerFirstValueChanged="false"
                @OnValueChanged="AddSubItem($event, true)"
                :items="itemsMenuSelect"
                :canType="true"
                v-tooltip="'Nuevo subítem'"
                icon="plus">
                </input-select>
            </div>
        </div>

        <div class="flex align-center mb15 well" v-for="(subitem, index) in subItems" :key="index">
            <input-field
            v-model="subitem.title"
            class="flex-fill mr5">
            </input-field>

            <input-field
            v-model="subitem.quantity"
            :placeholder="inventory[subitem.title]? `Cantidad ${inventory[subitem.title].unit}` : 'Cantidad'"
            type="float+"
            :suffix="` ${inventory[subitem.title]? inventory[subitem.title].unit : ''}`"
            class="flex-fill ml5">
            </input-field>

            <i class="options icon-trash ml10" @click.stop="subItems.splice(index, 1)"></i>
        </div>
        <div class="secondary-text ta-center" v-if="!subItems.length">No hay sub ítems</div>
    </div> 
    
    <button slot="actions" class="primary purple" @click="EditItem()">Editar</button>
</modal>

<modal v-model="modalItem" :dir="['right', 'right']" :modalClass="['fill', 'md right h100']" :title="modalItem? modalItem.item.title : ''" hideActions>

    <input-range slot="options"
    v-if="modalItem"
    v-model="modalItem.range"
    v-show="modalItem.tab == 'Resumen' && (!modalItem.item.subitems || !modalItem.item.subitems.length)"
    @OnValueChanged="LoadItemStats" 
    inputClass="secondary"
    :icon="mobile ? 'datetime' : ''"
    :triggerFirstValueChanged="false">
    </input-range>

    <input-date :icon="mobile ? 'calendar' : null" 
    v-if="modalItem"
        slot="options"
        v-show="modalItem && modalItem.tab == 'Historial'"
        inputClass="secondary" 
        type="DATE"
        format="timestamp"
        v-model="modalItem.dateFilter"
        modalOnly
        :toEndDay="true"
        @OnAcceptDate="LoadItemHistory()">
    </input-date>

    <tabs v-if="modalItem" v-model="modalItem.tab" :tabs="itemTabs" :keyByTab="true" 
    @OnTabResumen="modalItem.stats == null ? LoadItemStats(modalItem.range) : null"
    @OnTabProveedores="modalItem.providers == null ? ItemStats(modalItem.item, 'providers') : null"
    @OnTabHistorialdeCostos="modalItem.history_costs.length == 0 ? LoadItemCostHistory() : null"
    @OnTabHistorial="modalItem.history.length == 0 ? LoadItemHistory() : null">
        <div slot="Resumen">
            <div class="section">
                <div>
                    <div class="flex column" v-if="modalItem.stats">
                        <div class="flex column">
                            <div class="mb15">
                                <div class="bold">Total Utilizado</div>
                                <div>{{Util.Number(modalItem.stats.total_used)}} <span v-if="modalItem.item.unit" class="secondary-text">{{modalItem.item.unit}}</span></div>
                            </div>
                            <div class="mb15">
                                <div class="bold">Total Ingresado</div>
                                <div>{{Util.Number(modalItem.stats.total_added)}} <span v-if="modalItem.item.unit" class="secondary-text">{{modalItem.item.unit}}</span></div>
                            </div>
    
                            <div class="">
                                <div class="bold">Total Gastado</div>
                                <div>{{Util.Price(modalItem.stats.total_money)}}</div>
                            </div>
                        </div>
                        <div class="separator mb10 mt10"></div>        
                    </div>
                
                    <div class="flex align-center mb15">
                        <div class="">
                            <div class="bold">Total Disponible</div>
                            <div>{{Util.Number(modalItem.item.quantity)}} <span v-if="modalItem.item.unit" class="secondary-text">{{modalItem.item.unit}}</span></div>
                        </div>
                        <div class="i icon icon-arrow-right mr20 ml20" v-if="modalItem.item.performance && modalItem.item.performance != 100"></div>
                        <div class="" v-if="modalItem.item.performance && modalItem.item.performance != 100">
                            <div class="bold">Total Transformado</div>
                            <div>{{Util.Number(modalItem.item.quantity*modalItem.item.performance/100)}} <span v-if="modalItem.item.unit" class="secondary-text">{{modalItem.item.unit}}</span></div>
                        </div>
                    </div>
    
                    <div class="mb15">
                        <div class="bold">Costo unitario</div>
                        <div>${{Util.Number(modalItem.item.unit_cost)}} <span v-if="modalItem.item.unit" class="secondary-text">pesos/{{modalItem.item.unit}}</span></div>
                    </div>
                    <div class="flex align-center">
                        <div class="">
                            <div class="bold">Valor Disponible</div>
                            <div>{{Util.Price(modalItem.item.quantity * modalItem.item.unit_cost)}}</div>
                        </div>
                        <div class="i icon icon-arrow-right mr20 ml20" v-if="modalItem.item.performance && modalItem.item.performance != 100"></div>
                        <div class="" v-if="modalItem.item.performance && modalItem.item.performance != 100">
                            <div class="bold">Valor Transformado</div>
                            <div>{{Util.Price((modalItem.item.quantity*modalItem.item.performance/100) * modalItem.item.unit_cost)}}</div>
                        </div>
                    </div>
                    <div v-if="Object.values(modalItem.items_used).length">
                        <div class="separator mt20 mb20"></div>
                        <div class="bold">Utilizado En</div>
                        <ul>
                            <li v-for="(quantity, item) in modalItem.items_used" :key="item">
                                <span class="bold mr5">{{Util.Number(quantity)}}</span> <span class="secondary-text">{{modalItem.item.unit}}</span> en {{item}} 
                            </li>
                        </ul>
                    </div>
                    <div v-if="Object.values(modalItem.linked_items).length">
                        <div class="separator mt20 mb20"></div>
                        <div class="bold">Productos Enlazados</div>
                        <ul>
                            <li v-for="(data, index) in modalItem.linked_items" :key="index">
                                <span class="bold mr5">{{Util.Number(data.quantity)}}</span> <span class="secondary-text">{{modalItem.item.unit}}</span> en {{data.title}} <span v-if="data.type == 'modifier' || data.type == 'modifier_replacement'">- {{data.group}} - {{ data.modifier }}</span>
                                <div v-if="data.type == 'compound' && data.data" class="secondary-text">
                                    {{Util.Number(data.data.compound_quantity)}} {{data.data.compound_unit}} {{data.data.compound_item}} x {{Util.Number(data.data.base_quantity)}} {{data.data.base_unit}} {{data.data.base_item}}
                                </div>
                            </li>
                        </ul>
                    </div>
                    <div v-if="Object.values(modalItem.linked_compound_items).length">
                        <div class="separator mt20 mb20"></div>
                        <div class="bold">Inventario Compuestos Enlazados</div>
                        <ul>
                            <li v-for="(data, item) in modalItem.linked_compound_items" :key="item">
                                <span class="bold mr5">{{Util.Number(data.subitem_quantity)}}</span> <span class="secondary-text">{{modalItem.item.unit}}</span> en {{item}} 
                            </li>
                        </ul>
                    </div>
                </div>
                
            </div>
        </div>

        <vertical-content slot="Historial de Costos" @OnBottom="LoadItemCostHistory()">
            <div class="section" v-if="modalItem.history_costs.length > 0">

                <chart v-if="modalItem.history_costs.length > 1" class="mb20"
                type="line"
                :data="[Util.ReverseArr(modalItem.history_costs.slice(0, 20))]"
                dataset="unit_cost"
                :label="(data) => {return Util.Date(data.date)}"
                height="200px"
                :yLabelFormat="(value) => {return '$'+Util.Number(value)}"
                :tooltip="(value, label, index) => {return `$${Util.Number(value)} ${modalItem.history_costs[index].custom_data.provider ? ('(' + modalItem.history_costs[index].custom_data.provider.name + ')') : ''}`}"
                :customColor="[Util.Chart.purpleGradient]">
                </chart>

                <div class="entry selectable"
                v-for="(transaction, index) in modalItem.history_costs"
                :key="index"
                @click="$refs.inventoryDetails.Open(transaction)">
                    <div class="fill flex align-center">
                        <div class="flex-fill flex column">
                            <div class="bold">{{transaction.item}}</div>
                            <div class="secondary-text"><span class="bold">Fecha:</span> {{Util.Date(transaction.date, 'DD/MM/YYYY HH:mm')}}</div>
                            <div class="secondary-text" v-if="transaction.custom_data.provider"><span class="bold">Proveedor:</span> {{transaction.custom_data.provider.name}} - {{Util.Rut(transaction.custom_data.provider.rut)}}</div>
                        </div>
                        <div>
                            <span class="bold">${{Util.Number(transaction.unit_cost)}} </span>
                            <span class="secondary-text" v-if="inventory[transaction.item] && inventory[transaction.item].unit">pesos/{{inventory[transaction.item].unit}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="secondary-text mt20 ta-center">No hay datos.</div>
        </vertical-content>

        <div slot="Proveedores" class="pa20">
            <div class="flex column" v-if="modalItem.providers && modalItem.providers.length">

                <div :class="`entry ${provider.history.length > 1 ? 'selectable' : ''}`" 
                v-for="(provider, index) in modalItem.providers" :key="'provider'+index" @click="$set(modalItem, 'selectedProvider', provider.provider.name)"
                v-tooltip="'Ver historial de costos'">
                    <div class="flex align-center">
                        <div class="flex-fill">
                            <div class="bold">{{provider.provider.name}}</div>
                            <div class="secondary-text">{{Util.Rut(provider.provider.rut)}}</div>
                        </div>
                        <div>
                            <div class="bold ta-right">${{Util.Number(provider.history[provider.history.length-1].unit_cost)}}</div>
                            <div class="secondary-text ta-right" v-if="modalItem.item.unit">pesos / {{modalItem.item.unit}}</div>
                        </div>
                        <!--<i v-if="provider.history.length > 1" class="options icon-arrow-down ml5" @click="$set(modalItem, 'selectedProvider', provider.provider.name)"></i>-->
                    </div>
                    <chart v-if="provider.history.length > 1 && modalItem.selectedProvider == provider.provider.name" class="well mt10"
                    type="line"
                    :data="[provider.history]"
                    dataset="unit_cost"
                    :label="(data) => {return Util.Date(data.date)}"
                    height="200px"
                    :yLabelFormat="(value) => {return '$'+Util.Number(value)}"
                    :tooltip="(value, label, index) => {return `$${Util.Number(value)}`}"
                    :customColor="[Util.Chart.purpleGradient]">
                    </chart>
                </div>
            </div>
            <div v-else class="secondary-text ta-center mt10">No hay datos disponibles</div>
        </div>

        <vertical-content ref="verticalItemHistory" slot="Historial" @OnBottom="LoadItemHistory(true)" class="pa20">
            <div class="" v-if="modalItem.history.length > 0">
                <div class="entry selectable"
                v-for="(transaction, index) in modalItem.history"
                :key="index"
                @click="$refs.inventoryDetails.Open(transaction)">
                    <div class="fill flex align-center">
                        <div class="flex-fill flex column">
                            <div class="">
                                <span :class="`bold ${transaction.quantity < 0 ? 'cred' : 'cgreen'}`">{{Util.Number(transaction.quantity, false, true)}}</span> <span class="secondary-text ml5" v-if="inventory[transaction.item] && inventory[transaction.item].unit">{{inventory[transaction.item].unit}}</span>
                                <span class="bold ml5">{{transaction.item}}</span>
                            </div>
                            <div class="secondary-text" v-if="transaction.comment"><span class="bold">Comentario:</span> {{transaction.comment}}</div>
                            <!-- <div class="secondary-text">{{transaction.quantity_from}} <i class="icon icon-arrow-right"></i> {{transaction.quantity_to}}</div> -->
                            <!-- <div class="secondary-text" v-if="transaction.id_transaction">Utilizado en el pedido X</div> -->
                            <div class="secondary-text" v-if="transaction.custom_data.created_by"><span class="bold">Ingresado por:</span> {{transaction.custom_data.created_by}}</div>
                            <div class="secondary-text"><span class="bold">Fecha:</span> {{Util.Date(transaction.date, 'DD/MM/YYYY HH:mm')}}</div>
                            <div class="secondary-text cred" v-if="transaction.deleted_at"><span class="bold">Eliminado:</span> {{Util.Date(transaction.deleted_at, 'DD/MM/YYYY HH:mm')}}</div>
                            <div class="secondary-text cyellow" v-if="!transaction.expense_turn" title="No se muestra en reportes de Turno"><span class="bold"><i class="icon icon-circle-exclamation mr5"></i> No contabilizado en turno</span></div>
                        </div>
                        <div :class="transaction.deleted_at ? 'line-through' : 'bold'" v-if="transaction.money">{{Util.Price(transaction.money)}}</div>
                        <!--<i class="icon icon-arrow-right-o c4 ml10"></i>-->
                    </div>
                </div>
            </div>
            <div v-else class="secondary-text mt10 ta-center">No hay datos.</div>
        </vertical-content>
    </tabs>
</modal>

<modal v-model="modalItemComposite" :dir="['right', 'right']" :modalClass="['fill', 'md right h100']" :title="modalItemComposite? modalItemComposite.title : ''" hideActions>

    <div v-if="modalItemComposite" class="section">
        <div class="mb15">
            <div class="bold">Total Disponible</div>
            <div>{{Util.Number(modalItemComposite.quantity)}} <span v-if="modalItemComposite.unit" class="secondary-text">{{modalItemComposite.unit}}</span></div>
        </div>

        <div class="mb15">
            <div class="bold">Costo unitario</div>
            <div>${{Util.Number(modalItemComposite.unit_cost)}} <span v-if="modalItemComposite.unit" class="secondary-text">pesos/{{modalItemComposite.unit}}</span></div>
        </div>
        
        <div class="">
            <div class="bold">Valor Disponible</div>
            <div>{{Util.Price(modalItemComposite.quantity * modalItemComposite.unit_cost)}}</div>
        </div>
        
        <div class="separator mt20 mb20"></div>
        
        <div class="mb15">
            <div class="f18">Sub Items</div>
        </div>

        <div>
            <div v-for="(subitem, index) in modalItemComposite.subitems" :key="index" 
            class="well mb10 flex fill selectable align-center"
            @click="inventory[subitem.title] ? ItemStats(inventory[subitem.title]) : null">
                <avatar class="mr10"
                :imageIcon="subitem.title"
                defaultImageIcon="799"
                :color="ItemColor(inventory[subitem.title], true)">
                </avatar>

                <div class="flex-fill flex column">
                    <span class="bold">{{subitem.title}}</span>
                    <div class="secondary-text" v-if="inventory[subitem.title] && inventory[subitem.title].unit_cost">Costo unitario: ${{Util.Number(inventory[subitem.title].unit_cost)}}<span v-if="inventory[subitem.title]" class="secondary-text ml5">{{inventory[subitem.title].unit}}</span></div>
                    <div class="secondary-text" v-if="inventory[subitem.title]">Cantidad disponible: {{Util.Number(modalItemComposite.auto_calculate_quantity ? inventory[subitem.title].quantity : modalItemComposite.subitems.find(i => i.title == subitem.title).base )}}<span v-if="inventory[subitem.title]" class="secondary-text ml5">{{inventory[subitem.title].unit}}</span></div>
                    <div class="secondary-text cyellow" v-if="!inventory[subitem.title]"><i class="icon icon-circle-exclamation"></i> Este item no existe en el Inventario</div>
                </div>
                <div class="flex column" style="text-align: right">
                    <div>
                        <span class="bold">{{Util.Number(subitem.quantity)}}</span>
                        <span v-if="inventory[subitem.title]" class="secondary-text ml5">{{inventory[subitem.title].unit}}</span>
                    </div>
                </div>
                <i v-if="inventory[subitem.title]" @click.stop="GoToSubItemStats(modalItemComposite, subitem)" class="options icon-add-box ml10" v-tooltip="'Agregar '+subitem.title"></i>
            </div>
        </div> 
            
        
    </div>

</modal>

<modal v-model="modalItemResumenHistory" dir="right" :modalClass="['fill', 'sm right h100']" title="Historial de Transacciones" hideActions>
    <vertical-content class="pa20" v-if="modalItemResumenHistory && modalItemResumenHistory.history && modalItemResumenHistory.history.length > 0" @OnBottom="LoadHistoryResumen(modalItemResumenHistory.item)">
        <div class="entry selectable"
        v-for="(record, index) in modalItemResumenHistory.history"
        :key="index"
        @click="$refs.inventoryDetails.Open(record)">
        
        <div class="fill flex align-center">
                <div class="flex-fill flex column">
                    <div>
                        <span :class="`bold ${record.quantityShow < 0 ? 'cred' : 'cgreen'}`">
                            {{Util.Number(record.quantityShow, false, true)}}
                        </span> 
                        <span class="secondary-text ml5" v-if="inventory[record.item] && inventory[record.item].unit">{{inventory[record.item].unit}}</span>
                        <span class="bold ml5">{{record.item}}</span>
                    </div>
                    <div class="secondary-text" v-if="record.createdBy"><span class="bold">Ingresado por:</span> {{record.createdBy}}</div>
                    <div class="secondary-text"><span class="bold">Fecha:</span> {{Util.Date(record.date, 'DD/MM/YYYY HH:mm')}}</div>
                </div>
                <div class="bold" v-if="record.money">{{Util.Price(record.money)}}</div>
            </div>
        </div>
    </vertical-content>
    <div v-else class="secondary-text mt10 ta-center">No hay datos.</div>
</modal>

<modal v-model="modalItemWaste" dir="right" :modalClass="['fill', 'md right h100']" :title="modalItemWaste? 'Detalle del Item' : null" hideActions>
    <tabs v-if="modalItemWaste" 
    v-model="modalItemWaste.tab" 
    :tabs="itemWasteTabs" 
    :keyByTab="true"
    @OnTabHistorialdeTransacciones="LoadItemWasteHistory()">
        <div slot="Motivos">
            <div class="section">
                <div class="secondary-text ta-center" v-if="!Object.values(modalItemWaste.reasons).length">No hay datos.</div>
                <div class="entry" v-for="(reason, index) in modalItemWaste.reasons" :key="index">
                    <div class="fill flex align-center">
                        <div class="flex-fill flex column">
                            <div class="bold">{{reason.data}}</div>
                            <div class="secondary-text"><span class="bold">Cantidad:</span> {{reason.count}} de {{modalItemWaste.total_reasons}}</div>
                        </div>
                        <div>
                            <span class="bold">{{Percent(reason.count, modalItemWaste.total_reasons)}}%</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div slot="Historial de Transacciones">
            <div class="section" v-if="modalItemWaste && modalItemWaste.history && modalItemWaste.history.length > 0">
                <div class="entry selectable"
                v-for="(transaction, index) in modalItemWaste.history"
                :key="index"
                @click="$refs.inventoryDetails.Open(transaction)">
                    <div class="fill flex align-center">
                        <div class="flex-fill flex column">
                            <div class="flex bold">
                                <span class="cred">{{ Util.Number(transaction.quantity) }} <span class="secondary-text" v-if="inventory[transaction.item] && inventory[transaction.item].unit">{{inventory[transaction.item].unit}}</span></span> 
                                <span class="ml5">{{transaction.item}}</span>
                            </div>
                            <div class="secondary-text"><span class="bold">Fecha:</span> {{Util.Date(transaction.date, 'DD/MM/YYYY HH:mm')}}</div>
                            <!-- <div class="secondary-text"><span class="bold">Cantidad:</span> -{{Math.abs(transaction.quantity)}}</div> -->
                            <div class="secondary-text" v-if="transaction.comment"><span class="bold">Motivo:</span> {{transaction.comment}}</div>
                        </div>
                        <div>
                            <span class="bold">${{Util.Number(transaction.money)}} </span>
                            <span class="secondary-text" v-if="inventory[transaction.item] && inventory[transaction.item].unit">pesos/{{inventory[transaction.item].unit}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <div v-else class="secondary-text mt10 ta-center">No hay datos.</div>
        </div>
    </tabs>
</modal>

<modal v-model="modalTransferItem" dir="right" :modalClass="['fill', 'sm right h100']" :title="modalTransferItem? `Transferir ${modalTransferItem.title}` : null">
    <div v-if="modalTransferItem" class="pa20">
        <!-- <div class="mb15" v-if="typeof modalTransferItem.toSpace === 'string'">Movimiento de {{modalTransferItem.title}}</div> -->
        <div class="flex align-center mb15" v-if="!modalTransferItem.isCompoundTransfer">
            <div class="">
                <div class="bold">Espacio</div>
                <div><span>{{modalTransferItem.space}}</span></div>
            </div>
            <div class="mr30 ml30"></div>
            <div class="">
                <div class="bold">Ítem</div>
                <div><span>{{modalTransferItem.title}}</span></div>
            </div>
        </div>

        <div class="flex align-center mb15">
            <div class="">
                <div class="bold">Cantidad</div>
                <div><span>{{Util.Number(modalTransferItem.quantity)}}</span></div>
            </div>
            <i class="icon icon-arrow-right ml20 mr20 c4"></i>
            <div class="">
                <div class="bold">Nueva cantidad</div>
                <div><span>{{modalTransferItem.quantityTransfer? Util.Number(modalTransferItem.quantity - modalTransferItem.quantityTransfer) : Util.Number(modalTransferItem.quantity)}}</span></div>
            </div>
        </div>
        <template v-if="modalTransferItem.isCompoundTransfer">
            Origen
            <div class="mt10 mb15">
                <input-select v-model="modalTransferItem.fromItem"
                class="input"
                :items="inventoryTransferFrom"
                canType="search"
                :triggerFirstValueChanged="true"
                @OnValueChanged="AssignItemTransferFrom($event)">
                </input-select>
            </div>
        </template>
        <template>
            Destino
            <div class="mt10 mb15">
                <input-select v-model="modalTransferItem.toSpace"
                :class="showInventoryTransferInput ? 'input-top' : 'input-input'"
                :readonly="modalTransferItem.isCompoundTransfer"
                :items="spacesTransfer">
                </input-select>

                <input-select 
                v-model="modalTransferItem.toItem"
                v-if="showInventoryTransferInput"
                :readonly="modalTransferItem.isCompoundTransfer"
                class="input-bottom"
                :items="inventoryTransfer"
                canType="search"
                :triggerFirstValueChanged="false"
                @OnValueChanged="AssignItemTransfer($event)">
                </input-select>
            </div>
        </template>

        <input-field class="mb15"
        v-model="modalTransferItem.quantityTransfer"
        label="Cantidad a transferir"
        type="float+">
            <div class="append unshrink" slot="after" v-if="modalTransferItem.unit">{{modalTransferItem.unit}}</div>
        </input-field>

        <div class="flex align-center mb15" v-if="modalTransferItem.toItem && typeof modalTransferItem.toSpace === 'string' && (Local.type == 'FRANCHISE' || modalTransferItem.isCompoundTransfer)">
            <!-- <div class="mb15">Movimiento de {{this.modalTransferItem.toSpace}}</div> -->
            <div class="">
                <div class="bold">Cantidad</div>
                <div><span>{{Util.Number(QuantityModalTransfer())}}</span></div>
            </div>
            <i class="icon icon-arrow-right ml20 mr20 c4"></i>
            <div class="">
                <div class="bold">Nueva cantidad</div>
                <div><span>{{modalTransferItem.quantityTransfer? Util.Number(QuantityModalTransfer() + modalTransferItem.quantityTransfer) : Util.Number(QuantityModalTransfer())}}</span></div>
            </div>
        </div>
    </div>
    <label slot="actions" v-if="canExpenseTurn && modalTransferItem" style="flex: auto;" class="flex align-center">
        <input type="checkbox" v-model="modalTransferItem.expense_turn"> Contabilizar en turno<div class="checkmark"></div>
    </label>
    <button slot="actions" class="primary purple" @click="TransferItem()">Transferir</button>
</modal>

<!-- MODAL DE TRANSFERENCIA DE INVENTARIO DESDE FRANQUICIA HACIA SUBLOCAL -->
<modal v-model="modalTransferInventory" dir="right" :modalClass="['fill', 'md right h100']" title="Transferir Inventario">
    
    <input-select
    slot="options"
    v-if="modalTransferInventory"
    ref="CurrentItem"
    inputClass="icon primary"
    :triggerFirstValueChanged="false"
    @OnValueChanged="AddToInventory(modalTransferInventory.inventory, $event, 'Item sin stock para transferir.')"
    :items="itemsToArray"
    :canType="'search'"
    icon="plus">
    </input-select>
    
    <div v-if="modalTransferInventory" class="pa20">
        <div class="flex align-center mb20">
            <div class="bold mr10">Destino</div>
            <input-select v-model="modalTransferInventory.toSpace"
            class="input"
            :items="spacesTransfer">
            </input-select>
        
            <!--
            <input-select v-model="modalTransferInventory.toItem"
                
                v-if="!attachedSublocals"
                class="input-bottom"
                :items="inventoryTransfer"
                canType="search"
                :triggerFirstValueChanged="false"
                @OnValueChanged="AssignItemTransfer($event)">
            </input-select>
            -->
        </div>
        <div class="separator mb10 mt10"></div>
        <div class="flex well mb10 column" v-for="(item, index) in modalTransferInventory.inventory" :key="index">
            <div>{{ item.item.title }} </div>
            <div class="flex align-center">
                <div>
                    <div class="secondary-text">
                        <span class="bold">Cantidad: </span>
                        <span>{{ item.item.quantity }}</span><span v-show="item.item.unit" class="ml5">{{ item.item.unit }}</span>
                        <span v-if="item.item.quantityTransfer > 0"> > {{ item.item.quantity - item.item.quantityTransfer }} <span v-show="item.item.unit" class="ml5">{{ item.item.unit }}</span></span>
                    </div>
                    <input-field 
                    v-model="item.item.quantityTransfer"
                    type="number"
                    placeholder="Cantidad a transferir"
                    >
                    <div class="append unshrink" slot="after" v-if="item.item.unit">{{item.item.unit}}</div>
                    </input-field>
                </div>

                <div class="flex-fill"></div>
                <i class="options icon-trash ml10 c4 align-center" @click.stop="DeleteItemFromModal(index)"></i>
            </div>
        </div>
    </div>
    <label slot="actions" v-if="canExpenseTurn && modalTransferInventory" style="flex: auto;" class="flex align-center">
        <input type="checkbox" v-model="modalTransferInventory.expense_turn"> Contabilizar en turno<div class="checkmark"></div>
    </label>
    <button slot="actions" class="primary purple" @click="TransferItemFromFranchise()">Transferir</button>
</modal>
<!-- MODAL DE TRANSFERENCIA DE INVENTARIO DESDE FRANQUICIA HACIA SUBLOCAL -->

<!-- MODAL PARA AGREGAR MASIVAMENTE STOCK DE INVENTARIO -->
<modal v-model="modalAddMasiveStock" dir="right" :modalClass="['fill', 'lg right h100']" :title="modalAddMasiveStock && modalAddMasiveStock.waste ? 'Envio a Merma Masivo' : 'Agregar Inventario Masivo'">
    <input-select class="ml5"
    v-if="modalAddMasiveStock && !modalAddMasiveStock.hideItemSearch"
    ref="CurrentItem"
    inputClass="icon primary"
    :triggerFirstValueChanged="false"
    @OnValueChanged="AddToInventory(modalAddMasiveStock.inventory, $event, null)"
    :items="itemsToArray"
    :canType="'search'"
    icon="plus"
    slot="options">
    </input-select>
    <div v-if="modalAddMasiveStock" class="pa20">
        <div class="flex align-center mb20" :class="mobile? 'hdvm' : ''">
            <template v-if="modalAddMasiveStock && !modalAddMasiveStock.waste">
                <div class="bold mr10">Proveedor</div>
                <input-select
                v-model="modalAddMasiveStock.provider" 
                :items="providersItems" 
                canType="search">
                </input-select>
                <template v-if="modalAddMasiveStock.provider && modalAddMasiveStock.provider.rut">
                    <div class="bold ml10 mr10">Folio</div>
                    <input-field 
                    v-if="modalAddMasiveStock && modalAddMasiveStock.provider" 
                    v-model="modalAddMasiveStock.number" 
                    type="int+"
                    ></input-field>

                    <label :class="!mobile ? 'ml15' : 'mt10'" v-if="modalAddMasiveStock && modalAddMasiveStock.provider && modalAddMasiveStock.number" >
                        <input type="checkbox" v-model="modalAddMasiveStock.pending"> Pago pendiente <div class="checkmark"></div>
                    </label>
                </template>


            </template>
            <template v-else>
                <div class="bold mr10">Motivo</div>
                <input-select
                v-model="modalAddMasiveStock.comment"
                :items="reasonsWaste"
                :canType="true">
                </input-select>
            </template>


        </div>
        <div class="separator mb10 mt10" v-if="modalAddMasiveStock"></div>
        <div class="flex well mb10" v-for="(item, index) in modalAddMasiveStock.inventory" :key="index">
            <div class="flex-fill">
                <div class="flex column">
                    <div class="align-center flex mb10">
                        <div class="">{{ item.item.title }} </div>
                        <div class="ml5">( {{ item.item.quantity }} <span v-if="item.item.unit" class="secondary-text">{{item.item.unit}}</span> )</div>    
                    </div>
                    <div class="flex">
                        <div>
                            <div class="secondary-text">Cantidad</div>
                            <input-field 
                            v-model="item.add"
                            type="float+"
                            placeholder="0"
                            @OnChangeFocused="QuantityChanged($event, item)">
                                <div class="append unshrink" slot="after" v-if="item.unit">{{item.unit}}</div>
                            </input-field>
                        </div>
                        <div class="ml15">
                            <div class="secondary-text">{{mobile ? 'C.' : 'Costo'}} Unitario</div>
                            <input-field
                            v-model="item.unit_cost"
                            :placeholder="modalAddMasiveStock && modalAddMasiveStock.number ? '' : '(Opcional)'"
                            type="float"
                            prefix="$"
                            :readonly="(Auth.role === 'cashier' && !Auth.restrictions.can_edit_cost_unit) "
                            @OnChangeFocused="UnitCostChanged($event, item)">
                                <div class="append unshrink" slot="after" v-if="item.unit">$ x {{item.unit}}</div>
                            </input-field>
                        </div>
                        <div class="ml15">
                            <div class="secondary-text">{{mobile ? 'C.' : 'Costo'}} Total</div>
                            <input-field
                            v-model="item.cost"
                            placeholder="(Opcional)"
                            type="float"
                            prefix="$"
                            after=" "
                            :readonly="Auth.role == 'cashier' && !Auth.restrictions.can_edit_cost_unit && !item.unit_cost? true : false"
                            @OnChangeFocused="$event => CostChanged($event, item)">
                                <i class="icon icon-cross selectable" v-tooltip="'Quitar'" 
                                v-show="item.cost" slot="inner-after"
                                @click="$set(item, 'cost', null); $set(item, Auth.role == 'cashier' && !Auth.restrictions.can_edit_cost_unit? 'add' : 'unit_cost', null)"></i>
                            </input-field>
                        </div>
                        
                        <div class="flex-fill"></div>
                        <i class="options icon-trash ml10 c4 align-center" @click.stop="DeleteItemFromModal(index)"></i>

                    </div>

                </div>
            </div>
        </div>
    </div>
    <label slot="actions" v-if="canExpenseTurn && modalAddMasiveStock" style="flex: auto;" class="flex align-center">
        <input type="checkbox" v-model="modalAddMasiveStock.expense_turn"> Contabilizar en turno<div class="checkmark"></div>
    </label>
    <button class="secondary" slot="actions" @click="LoadMassiveStockUnitCost()" v-if="modalAddMasiveStock && !modalAddMasiveStock.number">Cargar Costo Unitario</button>
    <button slot="actions" class="primary" :class="modalAddMasiveStock&& modalAddMasiveStock.waste ? 'error-color' : 'pruple'" @click="AddMultiStock()">{{modalAddMasiveStock && modalAddMasiveStock.waste ? 'Enviar a Merma' : 'Agregar'}}</button>
</modal>
<!-- MODAL PARA AGREGAR MASIVAMENTE STOCK DE INVENTARIO -->

<!-- ---- MODAL PARA CONFIRMACION DE IMPRESION ---- -->
<modal v-model="modalConfirm.show" modalClass="md">
    <div class="pa20">
        <div v-if="modalConfirm.show" class="ta-center mb10" v-html="modalConfirm.title"></div>
        <div class="flex justify-center">
            <label>
                <input type="checkbox" v-model="modalConfirm.tempDoNotShowAgain">No volver a mostrar<div class="checkmark"></div>
            </label>
        </div> 
    </div>

    <button slot="actions"  @click="modalConfirm.show = false" class="secondary">Cancelar</button>
    <button slot="actions" class="primary" @click="PrintVoucher()">Imprimir</button>
</modal>
<!-- ---- MODAL PARA CONFIRMACION DE IMPRESION ---- -->

<!-- MODAL DISPONIBILIDAD TOTAL -->
<modal v-model="modalValueAvailable" dir="right" :modalClass="['fill', 'sm right h100']" title="Valor Disponible de Inventario">

    <div class="pa20">
        <div :class="`mb20 ${item.quantity < 0 ? 'cred' : ''}`"  v-for="(item, index) in modalValueAvailable" :key="index"> 
            <div><span class="bold">{{item.title}}</span> <span class="secondary-text"> {{`(${item.unit ? item.quantity+' '+item.unit : item.quantity})`}}</span> </div>
            <div>{{Util.Price(item.quantity * item.unit_cost)}}</div>
        </div>
    </div>

    <div slot="actions">
       Total Disponible {{Util.Price(CalculateSumValueAvailable(modalValueAvailable))}}
    </div>
</modal>
<!-- MODAL DISPONIBILIDAD TOTAL -->

<!-- MODAL PARA COMPARAR STOCK DE INVENTARIO -->
<modal v-model="modalCompareStock" dir="right" :modalClass="['fill', 'lg right h100']" title="Comparar Inventario">
    <input-field 
    v-model="searchCompareInventory" 
    placeholder="Buscar..."
    pre="search"
    cleareable
    inputClass="secondary"
    :timeout="300"
    :icon="mobile ? 'search' : ''"
    useHeader
    slot="options"
    >
    </input-field>
    <div v-if="modalCompareStock" class="pa20">
        
        <div class="well mb10" v-for="(item, index) in inventoryAlphabeticalOrder" :key="index">
            <div class="flex mb10 bold" :class="{cred: item.new_stock < item.quantity, cgreen : item.new_stock > item.quantity}">
                <span>{{ `${item.quantity}`}}
                    <span class="ml5 mr5 secondary-text">{{item.unit}}</span>
                </span>{{item.title}}
            </div>  
            <input-field v-model="item.new_stock" type="float+" cleareable placeholder="Nueva Cantidad" :suffix="item.unit ? ` ${item.unit}` : ''">
                <div slot="before" class="append primary bold">Cantidad actual</div>
            </input-field>
        </div>
    </div>
    <label slot="actions" v-if="canExpenseTurn && modalCompareStock" style="flex: auto;" class="flex align-center">
        <input type="checkbox" v-model="modalCompareStock.expense_turn"> Contabilizar en turno<div class="checkmark"></div>
    </label>
    <button slot="actions" class="primary purple" @click="UpdateInventoryStock()">Cambiar Inventario</button>
</modal>
<!-- MODAL PARA COMPARAR STOCK DE INVENTARIO -->

<inventory-details ref="inventoryDetails" :units="inventory" @OnTransactionDeleted="OnInventoryTransactionDeleted" @OnEditInvoice="$refs.providerList.ModalEditInvoice($event)"></inventory-details>

<sku-reader @OnSKU="OnSKU"></sku-reader>

</div>
</template>

<script>
import SkuReader from '../common/SkuReader.vue';
export default {
    components: {SkuReader},
    data() {
        return {
            inventory: {},
            payMethods: [{text: 'Sin definir', value: 'UNDEFINED'}],
            modalAdd: null,
            modalNew: null,
            modalItem: null,
            modalEdit: null,
            history: [],
            historyPage: 0,
            range: null,
            stats: null,
            tab: null,
            dateFilter : null,
            search: '',
            tabs: null,
            itemTabs: null,
            providers: null,
            modalProvider: null,
            modalInvoice: null,
            modalProviderStats: null,
            orderBy: 'QUANTITY',
            modalLastInvoices: null,
            searchProvider: '',
            pendingInvoices: {},
            orderByOptions: [{text: 'Cantidad', value: 'QUANTITY'}, {text: 'Nombre', value: 'NAME'}],
            modalProviderItem: null,
            reasonsWaste: [
                {text: 'Sin definir', value: 'Sin definir'},
                {text: 'Mercancía vencida', value: 'Mercancía vencida'},
                {text: 'Exceso de inventario', value: 'Exceso de inventario'},
                {text: 'Robos', value: 'Robos'},
                {text: 'Mercancía dañada', value: 'Mercancía dañada'}
            ],
            itemsWaste: null,
            localFilterItemsWaste: null,
            modalItemWaste: null,
            rangeWaste: {
                option: 'MONTH',
                index: 0
            },
            subItems: [],
            searchResumen: null,
            modalItemResumenHistory: null,
            ModalImportInventory: null,
            orderSpace: 'General',
            modalItemComposite: null,
            modalTransferItem: null,
            modalTransferInventory : null,
            modalAddMasiveStock : null,
            modalConfirm : { show : false, doNotShowAgain : false, tempDoNotShowAgain: false },
            itemsToArray : [],
            // attachedSublocals: null,
            attachedFranchises: null,
            modalValueAvailable : null,
            inventoryOption : 'IGNORE',
            modalCompareStock : null,
            searchCompareInventory : '',
            localsOptionsTransfer: [],
            searchRecord : '',
            orderByRecord: 'ALL',
            orderByOptionsHistorial: [{text : 'Todos', value: 'ALL'},{text: 'Agregados', value: 'ADD'}, {text: 'Descuentos', value: 'MINUS'}],
        }
    },
    mounted() {

        this.tabs = [];
        if(this.Local.modules.module_inventory) this.tabs.push('Actual');
        if(this.Local.modules.module_inventory && this.isAdmin) this.tabs.push('Merma');
        if(this.canCreateProvider || this.canEditProvider || this.canCreateInvoices || this.canPayInvoices)
            if(this.Local.modules.module_inventory) this.tabs.push('Proveedores');
        if(this.Local.modules.module_inventory && this.isAdmin) this.tabs.push('Resumen');
        if(this.Local.modules.module_inventory && this.isAdmin) this.tabs.push('Historial');

        this.itemWasteTabs = [];
        if(this.Local.modules.module_inventory) this.itemWasteTabs.push('Motivos');
        if(this.Local.modules.module_inventory) this.itemWasteTabs.push('Historial de Transacciones');

        this.Loading();
        axios.get(`/inventory/${this.Local.id}`).then(res => {
            this.inventory = this.Util.CalculateInventoryComposite(res.data.items);
            this.localsOptionsTransfer = res.data.localsFranchises;
            for(var i = 0; i < res.data.methods.length; i++)
                this.payMethods.push({text: this.Util.PayMethod(res.data.methods[i]), value: res.data.methods[i]});
            this.Response(res);
        }).catch(err => {
            this.Response(err);
        });

        this.LoadProviders();


        if(this.Local.type == "FRANCHISE"){
            axios.get(`/sublocals/${this.Local.id}`).then( ({data}) => {
                // this.attachedSublocals = data.attached;
                this.attachedFranchises = data.attachedFranchises;
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        }

        var moment = require('moment');
        this.range = {
            option: 'MONTH',
            index: 0,
            label: 'Este mes',
            rangeStart: moment().startOf('month').unix(),
            rangeEnd: moment().endOf('month').unix(),
        };

        this.rangeWaste = {
            option: 'MONTH',
            index: 0,
            label: 'Este mes',
            rangeStart: moment().startOf('month').unix(),
            rangeEnd: moment().endOf('month').unix(),
        }
        
        this.sse.On('INVENTORY_UPDATED', this.UpdateInventory);

    },
    methods: {
        CalculateSumUsed(array) {
            let sumaTotal = 0;
            if(array){      
                array.forEach((element) => {
                    if(element.total_used < 0) element.total_used = element.total_used * -1;
                    if(this.inventory[element.data])
                    {
                        let total = element.total_used * this.inventory[element.data].unit_cost
                        sumaTotal += total
                    }
                });
            }
            return sumaTotal;
        },
        CalculateSumValueAvailable(array) {
            let sumaTotal = 0;
            for (const itemName in array) {
                const { quantity, unit_cost } = array[itemName];
                if(quantity > 0)
                    sumaTotal += quantity * unit_cost;
            }
            return sumaTotal;
        },
        ShowModalInventoryValueAvailable(){
            this.modalValueAvailable = []
            for (const itemName in this.inventory) {
                //Si subitems es NULL o tiene longitud 0, se agrega a la lista. No se permiten item que tengan subitems
                if (!this.inventory[itemName].subitems || this.inventory[itemName].subitems.length === 0) {
                    this.modalValueAvailable.push(this.inventory[itemName]);
                }
            }
            //Se ordeba alfabeticamente la lista
            this.modalValueAvailable = Util.NaturalSort(this.modalValueAvailable)
        },
        UpdateInventory()
        {
            axios.get(`/inventory/${this.Local.id}`).then(res => {
                this.inventory = this.Util.CalculateInventoryComposite(res.data.items);
                if(this.modalItemComposite && this.inventory[this.modalItemComposite.title]) this.modalItemComposite = this.inventory[this.modalItemComposite.title];
            });
        },
        CreateInventoryItem() {
            if(!this.modalNew.title || !this.modalNew.title.trim()) return this.Info('Datos inválidos');
            let validateSubitem = null;
            if(this.subItems.length > 0){
                this.subItems.forEach( (subitem, indexSubitem) => {
                    subitem.title = subitem.title.trim();
                    if(!subitem.title || subitem.title == '') return validateSubitem = `Hay un subítem sin nombre`;
                    if(!subitem.quantity || isNaN(subitem.quantity) || subitem.quantity <= 0) return validateSubitem = `Revise la cantidad de ${subitem.title}`;
                    console.log(this.modalNew.title.toUpperCase(), subitem.title);
                    if(this.modalNew.title.toUpperCase() == subitem.title) return validateSubitem = `Nombre de subítem ${subitem.title} inválido`;
                    if(!this.modalNew.auto_quantity) subitem.base = 0; 
                    this.$set(this.subItems[indexSubitem], 'title', subitem.title.toUpperCase());
                });
                this.$set(this.modalNew, 'performance', 100);
            }
            if(validateSubitem) return this.Info(validateSubitem);
            if(!this.modalNew.performance || isNaN(this.modalNew.performance) || parseFloat(this.modalNew.performance) <= 0) return this.Info('Rendimiento inválido');
            var item = this.modalNew.title.toUpperCase();
            this.$set(this.modalNew, 'subItems', this.subItems);
            if(this.inventory[item]) return this.Info('El item ingresado ya existe.');
            this.Loading();
            axios.put(`/inventory/${this.Local.id}`, this.modalNew).then( ({data}) => {
                data.forEach( item => {
                    this.$set(this.inventory, item.title, item);
                });
                this.inventory = this.Util.CalculateInventoryComposite(this.inventory);
                this.Response(data);
                this.subItems = [];
                this.modalNew = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        EditItem() {
            if(!this.modalEdit.performance || isNaN(this.modalEdit.performance) || parseFloat(this.modalEdit.performance) <= 0) return this.Info('Rendimiento inválido');
            let validateSubitem = null;
            if(this.subItems.length > 0){
                this.subItems.forEach( (subitem, indexSubitem) => {
                    if(!subitem.title || subitem.title == '') return validateSubitem = `Hay un subítem sin nombre`;
                    if(!subitem.quantity || isNaN(subitem.quantity) || subitem.quantity <= 0) return validateSubitem = `Revise la cantidad de ${subitem.title}`;
                    if(this.modalEdit.title.toUpperCase() == subitem.title) return validateSubitem = `Nombre de subítem ${subitem.title} inválido`;
                    if(!this.modalEdit.auto_quantity && !subitem.base) subitem.base = 0;
                    let subCheck = this.inventory[subitem.title.toUpperCase()];
                    if(subCheck && subCheck.subitems && subCheck.subitems.length > 0) {
                        subCheck.subitems.forEach(sub => {
                            if(sub.title == this.modalEdit.title) return validateSubitem = `El subítem ${subitem.title} ya tiene como subitem a ${this.modalEdit.title}. Puede causar recursividad.`;
                        });
                    }
                    this.$set(this.subItems[indexSubitem], 'title', subitem.title.toUpperCase());
                });
                this.$set(this.modalEdit, 'performance', 100);
            }
            if(validateSubitem) return this.Info(validateSubitem);
            this.modalEdit.performance = parseFloat(this.modalEdit.performance);
            this.$set(this.modalEdit, 'subItems', this.subItems);
            if(this.modalEdit.title == this.modalEdit.title_replace.trim()) delete this.modalEdit.title_replace; // Si el nombre de reemplazo es igual al nombre actual del item, se elimina la variable title_replace
            this.Loading();
            axios.patch(`/inventory/${this.Local.id}`, this.modalEdit).then( ({data}) => {
                if(this.modalEdit.title_replace) this.$delete(this.inventory, this.modalEdit.title);
                data.forEach( item => {
                    this.$set(this.inventory, item.title, item);
                });
                this.inventory = this.Util.CalculateInventoryComposite(this.inventory);
                this.Response(data);
                this.modalEdit = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        CheckConfirm(r){
            this.modalConfirm.data_response = r.data.transaction;
            if(this.modalConfirm.doNotShowAgain) {
                this.PrintVoucher();
                return;
            }
            this.modalConfirm.tempDoNotShowAgain = this.modalConfirm.doNotShowAgain;
            this.modalConfirm.show = true;
            this.modalConfirm.title = '¿Imprimir voucher de movimiento de inventario?';
        },
        AddStock(waste) {
            
            if(!this.modalAdd.add) return this.Info('La cantidad a agregar debe ser distinta de cero.');
            if(this.Auth.restrictions && this.Auth.restrictions.required_payment_methods && this.modalAdd.pay_method == 'UNDEFINED' && this.modalAdd.unit_cost > 0) return this.Info('Debe seleccionar un método de pago.');
            if(this.modalAdd.provider && this.modalAdd.add < 0) return this.Info('No se puede descontar inventario con un proveedor');

            //if(waste) this.modalAdd.add = -this.modalAdd.add;
            
            if(!this.modalAdd.waste || this.modalAdd.addCost)
            {
                if(this.modalAdd.cost) 
                {
                    if(isNaN(this.modalAdd.cost) || this.modalAdd.cost < 0) return this.Info('Costo inválido');
                    this.modalAdd.unit_cost = this.Util.RoundFloat(this.modalAdd.cost / this.modalAdd.add);
                }
                else if(this.modalAdd.unit_cost) 
                {
                    if(isNaN(this.modalAdd.unit_cost) || this.modalAdd.unit_cost < 0) return this.Info('Costo unitario inválido');
                    this.modalAdd.cost = this.modalAdd.unit_cost * this.modalAdd.add;
                }
            }

            if((this.modalAdd.waste || this.modalAdd.inventory_discount) && !this.modalAdd.addCost)
            {
                this.modalAdd.cost = null;
                this.modalAdd.unit_cost = null;
            }

            this.Loading();
            axios.post(`/inventory/${this.Local.id}/add?v2=true`, this.modalAdd).then(res => {
                this.inventory = this.Util.CalculateInventoryComposite(res.data.inventory);
                this.modalAdd = false;
                this.Response(res);
                this.history = [];
                this.CheckConfirm(res);

                // this.Confirm({
                //         title: '¿Imprimir voucher de movimiento de inventario?',
                //         text: 'Imprimir',
                //         class: 'selected-color',
                //         function: () => {this.$refs.inventoryDetails.PrintInventoryVoucher(res.data.transaction)}
                // });

            }).catch(err => {
                this.Response(err);
            });
        },
        AddMultiStock() {
            let validation = true
            if(this.modalAddMasiveStock.inventory.length === 0) return this.Info("Debe ingresar al menos 1 item")
            this.modalAddMasiveStock.inventory.forEach(element => {

                if(!element.hasOwnProperty('add')){
                    validation = false
                    return this.Info("Debe ingresar un valor de cantidad.");
                } 
                if(isNaN(element.add)){
                    validation = false
                    return this.Info("Debe ingresar un valor de cantidad.");
                } 
                if(element.add === 0){
                    validation = false
                    return this.Info("Valor de cantidad debe ser mayor a 0.");
                }

                if(this.modalAddMasiveStock.provider && this.modalAddMasiveStock.number && element.unit_cost <= 0 && element.item.subitems.length === 0){
                    validation = false
                    return this.Info('El costo unitario debe ser mayor a 0');
                }
            });
            if(validation){
                this.Loading();
                axios.post(`/inventory/${this.Local.id}/add?v2=true`, this.modalAddMasiveStock).then(res => {
                    this.inventory = this.Util.CalculateInventoryComposite(res.data.inventory);
                    this.modalAddMasiveStock = null;
                    this.Response(res);
                    this.history = [];
                    this.CheckConfirm(res)
                    // this.Confirm({
                    //         title: '¿Imprimir voucher de movimiento de inventario?',
                    //         text: 'Imprimir',
                    //         class: 'selected-color',
                    //         function: () => {this.$refs.inventoryDetails.PrintInventoryVoucher(res.data.transaction)}
                    // });

                }).catch(err => {
                    this.Response(err);
                });
            }

        },
        PrintVoucher(){
            this.$refs.inventoryDetails.PrintInventoryVoucher(this.modalConfirm.data_response)
            this.modalConfirm.doNotShowAgain = this.modalConfirm.tempDoNotShowAgain;
            this.modalConfirm.show = false
        },
        DeleteItem(item)
        {
            this.Loading();
            axios.post(`/inventory/${this.Local.id}`, {item: item.title}).then(res =>{
                this.inventory = this.Util.CalculateInventoryComposite(res.data);
                this.Response(res);
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadItemStats(range)
        {
            this.Loading();
            axios.post(`/inventory/${this.Local.id}/item/stats`, {item: this.modalItem.item.title, range: range}).then(res => {
                this.Response(res);
                this.$set(this.modalItem, 'stats', res.data.stats);
                this.$set(this.modalItem, 'items_used', res.data ? res.data.items_used : []);                
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadItemHistory(bottom=false)
        {
            if(!bottom) 
            {
                this.$set(this.modalItem, 'history', []);
                this.modalItem.historyPage = 0;
                this.$refs.verticalItemHistory.Reset();
            }
            if(bottom && !this.modalItem.history.length) return;
            this.$nextTick(() => {
                this.Loading();
                axios.post(`/inventory/${this.Local.id}/history/item/${this.modalItem.dateFilter}?page=${++this.modalItem.historyPage}`, {item: this.modalItem.item.title}).then(res => {
                    this.Response(res);
                    var history = bottom ? this.modalItem.history.concat(res.data.data) : res.data.data;
                    this.$set(this.modalItem, 'history', history);
                }).catch(err => {
                    this.Response(err);
                });
            })
        },
        LoadItemCostHistory()
        {
            this.Loading();
            if(!this.modalItem.historyCostPage) this.modalItem.historyCostPage = 0;
            axios.post(`/inventory/${this.Local.id}/history/item/cost?page=${++this.modalItem.historyCostPage}`, {item: this.modalItem.item.title}).then(res => {
                this.Response(res);
                var history = this.modalItem.history_costs.concat(res.data.data);
                this.$set(this.modalItem, 'history_costs', history);
                this.$forceUpdate();
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadHistory(bottom=false)
        {
            if(!bottom)
            {
                this.history = []
                this.historyPage = 0;
                this.$refs.verticalHistory.Reset();
            }
            if(bottom && !this.history.length) return;
            this.$nextTick(() => {
                this.Loading();
                axios.get(`/inventory/${this.Local.id}/history/${this.dateFilter}?page=${++this.historyPage}${this.searchRecord ? `&search=${this.searchRecord}` : ''}${this.orderByRecord && this.orderByRecord !== 'ALL' ? `&orderBy=${this.orderByRecord}` : ''}`).then(res => {
                    this.Response(res);
                    this.history = this.history.concat(res.data.data);
                }).catch(err => {
                    this.Response(err);
                });  
            })
        },
        ItemStats(item, updateKey) {

            if(item.subitems && item.subitems.length)
            {
                this.itemTabs = ['Resumen'];
                this.modalItemComposite = item;
                return;
            }

            this.Loading();
            axios.post(`/inventory/${this.Local.id}/item/stats?v2`, {item: item.title}).then(res => {
                this.Response(res);
                if(updateKey)
                {
                    this.$set(this.modalItem, updateKey, res.data[updateKey]);
                }
                else
                {
                    var data = res.data;
                    data.history = [];
                    data.history_costs = [];
                    data.dateFilter = this.Util.Date('now', 'timestamp');
                    this.modalItem = data;
                    this.itemTabs = [];
                    if(this.Local.modules.module_inventory) this.itemTabs.push('Resumen');
                    if(this.Local.modules.module_inventory) this.itemTabs.push('Historial de Costos');
                    if(this.Local.modules.module_inventory) this.itemTabs.push('Proveedores');
                    if(this.Local.modules.module_inventory) this.itemTabs.push('Historial');
                }
            }).catch(err => {
                this.Response(err);
            });
        },
        Search()
        {
            this.Loading();
            axios.post(`/inventory/${this.Local.id}/stats`, this.range).then(res => {
                this.Response(res);
                console.log(res.data);
                this.stats = res.data;
            }).catch(err => {
                this.Response(err);
            });
        },
        GenerateInventory()
        {
            this.Loading();
            axios.get(`/inventory/${this.Local.id}/generate`).then(res => {
                this.inventory = this.Util.CalculateInventoryComposite(res.data);
                this.Response(res);
            }).catch(err => {
                this.Response(err);
            });
        },
        Print(sections)
        {
            var moment = require('moment');
            var now = moment();
            var arr = [
                {text: 'Inventario ' + this.Local.name},
                {text: `Fecha: ${now.format('HH:mm DD/MM/YYYY')}`},
                {line: true},
            ];
            
            let inventory = this.Util.NaturalSort(Object.values(this.inventory), 'title');
            let grouped = {};

            inventory.forEach(inv => {
                let itemSpace = inv.space ? inv.space : 'General';
                if(itemSpace != this.orderSpace) return;
                let section = inv.section || 'Sin sección';
                if(!grouped[section]) grouped[section] = [];
                grouped[section].push(inv);
            });

            Object.entries(grouped).forEach(([section, items]) => {
                arr.push({text: `-- ${section} --`});
                items.forEach(inv => {
                    arr.push({ text: [ `${inv.title}${inv.unit ? ' (' + inv.unit + ')' : ''}`, this.Util.Number(inv.quantity)] });
                });

                // arr.push({line: true});
            });
            console.log(arr);

            this.Util.NotifyService('print', {data: arr, id: Math.random().toString()});
            
        },
        Export() 
        {

            this.Loading();
            axios.get(`/inventory/${this.Local.id}/export`, {responseType: 'blob'}).then(res => {
                this.Response(res);
                this.Util.DownloadFile(res, `inventario_${Util.Today().date.replace(/\//g, '-')}.xls`);
            }).catch(err => {
                this.Response(err);
            });
        },
        ExportResumen(){
            this.Loading();
            axios.post(`/inventory/${this.Local.id}/resumen/export`, this.range, {responseType: 'blob'})
            .then(res => {
                this.Response(res);
                this.Util.DownloadFile(res, `inventario_${Util.Today().date.replace(/\//g, '-')}.xls`);
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadProviders()
        {
            if (!this.canCreateProvider && !this.canPayInvoices && !this.canCreateInvoices && !this.canEditProvider) return;
            axios.get(`/providers/${this.Local.id}/v2${'?view=INVENTORY'}`).then(res => {
                this.Response(res);
                this.providers = res.data.providers;
                this.pendingInvoices = res.data.counts;
                if(this.$refs.providerList) {
                    this.$refs.providerList.providers = this.providers;
                    this.$refs.providerList.pendingInvoices = this.pendingInvoices;
                }
            }).catch(err => {
                this.Response(err);
            });
         
        },
        QuantityChanged(quantity, modal, isProvider){

            quantity = parseFloat(quantity);
            if(isNaN(quantity) || quantity == 0) return;

            var unitCost = parseFloat(modal[isProvider ? 'price' : 'unit_cost']);

            if(!isNaN(unitCost))
            {
                this.$set(modal, isProvider ? 'total_price' : 'cost', unitCost*quantity);
                return;
            }

            var totalCost = parseFloat(modal[isProvider ? 'total_price' : 'cost']);
            if(!isNaN(totalCost))
            {
                this.$set(modal, isProvider ? 'price' : 'unit_cost', totalCost / quantity);
                return;
            }
            
        },
        UnitCostChanged(unitCost, modal, isProvider)
        {
            var quantity = parseFloat(modal[isProvider ? 'quantity' : 'add']);

            if(isNaN(quantity)) return;
            unitCost = parseFloat(unitCost);
            if(isNaN(unitCost)) return this.$set(modal, isProvider ? 'total_price' : 'cost', '');
            this.$set(modal, isProvider ? 'total_price' : 'cost', unitCost * quantity);

        },
        CostChanged(cost, modal, isProvider)
        {

            var quantity = parseFloat(modal[isProvider ? 'quantity' : 'add']);
            if(isNaN(quantity) || quantity == 0) return;
            cost = parseFloat(cost);
            if(isNaN(cost)) return this.$set(modal, isProvider ? 'price' : 'unit_cost', '');
            if(!isProvider && modal.unit_cost && this.Auth.role == 'cashier' && !this.Auth.restrictions.can_edit_cost_unit) return this.$set(modal, 'add', cost / modal.unit_cost);
            this.$set(modal, isProvider ? 'price' : 'unit_cost', cost / quantity);
        },
        ItemColor(item, onModal = false)
        {
            
            if(onModal && this.modalItemComposite && !this.modalItemComposite.auto_calculate_quantity) {
                if(!item) return '#f3bb51'
                let find = this.modalItemComposite.subitems.find(i => i.title == item.title);
                if(find && find.base <= 0) return '#ff495b';
            } 
            
            if(!onModal && (!item || item.quantity <= 0)) return '#ff495b';
            return '#0cc683';

        },
        TitleProduct(modalAdd){
            if(modalAdd.item.title && modalAdd.waste) return `Enviar ${modalAdd.item.title} a merma`;
            else if(modalAdd.item.title && modalAdd.inventory_discount) return `Descontar inventario de ${modalAdd.item.title}`;
            else return `Agregar ${modalAdd.item.title}`;
        },
        SearchItemsWaste(callback){
            this.Loading();
            axios.post(`/inventory/waste/${this.Local.id}`, {...this.rangeWaste, localFilterItemsWaste: this.localFilterItemsWaste})
            .then(({data}) => {
                this.itemsWaste = data;
                this.Response(this.itemsWaste);
                if(callback) callback();
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadItemWasteHistory(){
            this.Loading();
            axios.post(`/inventory/waste/${this.Local.id}/history`, {
                item: this.modalItemWaste.data,
                date: this.rangeWaste,
                localFilterItemsWaste: this.localFilterItemsWaste
            }).then( ({data}) => {
                this.$set(this.modalItemWaste, 'history', data);
                console.log(this.modalItemWaste);
                this.Response(this.modalItemWaste);
            }).catch(err => {
                this.Response(err);
            });
        },
        Percent(amount, total) 
        {
            if(total <= 0) return '';
            return Math.round(100*amount/total);
        },
        AddToInventory(inventory, data, noStockMsg){
            if(!data) return;
            //Busca si el elemnto entrante existe en el array
            const itemExists = inventory.find(item => item.item.id === data.dataitem.id);

            //Si el elemento existe, retorna mensaje
            if (itemExists) return this.Info("Item ya se encuentra agregado en la lista.");
                
            // Si el stock del elemento es 0 y existe mensaje, retornara el mensaje 'Item sin stock para transferir.'
            // Esto solo aplica para cuando cuando se realizan "TRANSFERENCIAS MASIVAS" solo franquicia
            if(data.dataitem.quantity === 0 && noStockMsg) return this.Info(noStockMsg);
            this.$refs.CurrentItem.CleanCurrentItem();
            //En el caso que se "agregado masivo de stock"
            if(!noStockMsg){
                let unitCost = this.modalAddMasiveStock && this.modalAddMasiveStock.provider && this.modalAddMasiveStock.number ? data.dataitem.unit_cost : null;
                inventory.push({'item' : data.dataitem, 'pay_method' : 'UNDEFINED', 'unit_cost' : unitCost });
                return;
            }
            // En el caso que sea "transferencia masivo de stock"
            inventory.push({'item' : data.dataitem });
            
        },
        AddSubItem(item){
            if(!item) return;

            let title = typeof item == 'object'? item.title.toUpperCase() : item.toUpperCase();

            if(this.subItems.some(item => item.title == title)) return this.Info('El subítem ya ha sido agregado.');
            this.subItems.push({
                title
            });
        },
        ItemResumenHistory(item){
            this.Loading();
            axios.post(`/inventory/${this.Local.id}/resumen/history`, {item, range: this.range}).then( ({data}) => {
                if(data.status){
                    this.modalItemResumenHistory = {};
                    this.$set(this.modalItemResumenHistory, 'history', data.history);
                    this.$set(this.modalItemResumenHistory, 'item', data.item);
                } 
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        LoadHistoryResumen(item){
            let history = this.modalItemResumenHistory.history;
            let lastId = history.length ? history[history.length-1].id: null;
            this.Loading();
            axios.post(`/inventory/${this.Local.id}/resumen/history`, {
                lastDate: null,
                lastId: lastId,
                item,
                range: this.range
            }).then( ({data}) => {
                this.Response(data);
                this.modalItemResumenHistory.history = this.modalItemResumenHistory.history.concat(data.history);
            }).catch(err => {
                this.Response(err);
            });
        },
        ImportInventory(){
            if(!this.ModalImportInventory.file) return this.Info('Se debe seleccionar un archivo');
            let formData = new FormData();
            formData.append("file", this.ModalImportInventory.file);
            formData.append("option", this.inventoryOption)

            this.Loading();
            axios.post(`/inventory/${this.Local.id}/import`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then( ({data}) => {
                this.Info(data.msg);
                if(data.status){
                    if(data.items){
                        data.items.forEach( item => {
                            this.$set(this.inventory, item.title, item);
                        });
                    }

                    //Se actualiza toda la lista
                    if(data.inventory && Object.keys(data.inventory).length > 0){
                        this.inventory = this.Util.CalculateInventoryComposite(data.inventory);
                    }
                    //Se setea las opciones de importación
                    this.inventoryOption = 'IGNORE'
                }
                this.ModalImportInventory = null;
            }).catch(err => {
                this.Response(err);
            });
        },
        TransferItem(){
            if(!this.modalTransferItem) return;
            if(!isNaN(this.modalTransferItem.toSpace) && this.modalTransferItem.toItem) this.modalTransferItem.toItem = null;
            if(!this.attachedFranchises && !this.modalTransferItem.toItem && !this.modalTransferItem.toSpace) return this.Info(`El ítem de destino es obligatorio`);
            if(this.modalTransferItem.quantity <= 0) return this.Info(`No tiene cantidad suficiente para transferir`);
            if(!this.modalTransferItem.quantityTransfer) return this.Info(`La cantidad a transferir es obligatoria`);
            if(this.modalTransferItem.quantityTransfer > this.modalTransferItem.quantity) return this.Info(`La cantidad a transferir es superior a la cantidad disponible`);
            this.Loading();
            axios.patch(`/inventory/${this.Local.id}/item/transfer`, this.modalTransferItem).then( ({data}) => {
                this.inventory = this.Util.CalculateInventoryComposite(data.inventory);
                if(typeof this.modalTransferItem.toSpace === 'string') 
                    this.Info(`Se ha transferido ${this.modalTransferItem.quantityTransfer} ${this.modalTransferItem.unit ? this.modalTransferItem.unit : ''} de ${this.modalTransferItem.title} ${this.modalTransferItem.isCompoundTransfer ? '('+this.modalTransferItem.fromItem.title+')' : ''} a ${this.modalTransferItem.toItem.title}`);
                else
                    this.Info(`Se ha transferido ${this.modalTransferItem.quantityTransfer} ${this.modalTransferItem.unit ? this.modalTransferItem.unit : ''} de ${this.modalTransferItem.title} al local ${data.to_local}`)
                return this.modalTransferItem = null;
            }).catch(err => {
                this.Response(err);
                if(err.response.data.message) this.Info(err.response.data.message);
            });
        },
        TransferItemFromFranchise(){
            let validation = true
            if(this.modalTransferInventory.inventory.length === 0) return this.Info("Debe ingresar al menos 1 item para transferir inventario.")
            this.modalTransferInventory.inventory.forEach(element => {

                if(!element.item.hasOwnProperty('quantityTransfer')){
                    validation = false
                    return this.Info("Debe ingresar un valor a transferir.")
                } 
                if(isNaN(element.item.quantityTransfer)){
                    validation = false
                    return this.Info("Debe ingresar un valor a transferir.")
                } 
                if(element.item.quantityTransfer === 0){
                    validation = false
                    return this.Info("Valor a transferir debe ser mayor a 0.")
                }
                
                if(element.item.quantityTransfer > element.item.quantity){
                    validation = false
                    return this.Info(`${element.item.title} : La cantidad a transferir no puede ser mayor a la cantidad actual del Item, intente nuevamente.`)
                }
            });

            if(validation) {
                this.Loading();
                axios.patch(`/inventory/${this.Local.id}/item/transfer`, this.modalTransferInventory).then( ({data}) => {
                    this.inventory = this.Util.CalculateInventoryComposite(data.inventory);
                    let msg = ''
                    this.modalTransferInventory.inventory.forEach(element => {
                       msg += `<li>Se ha transferido ${element.item.quantityTransfer} ${element.item.unit ? element.item.unit : ''} de ${element.item.title}.</li>`
                    });
                    
                    this.Info(`Transferencia de inventario hacia ${data.to_local} <br><br>
                    <ul> ${msg} </ul>`)
                    
                    return this.modalTransferInventory = null;
                }).catch(err => {
                    this.Response(err);
                    if(err.response.data.message) this.Info(err.response.data.message);
                });
            }

        },        
        ClickModalAddStockTransfer(modal, waste = false){
            let expense = true;
            if (this.canExpenseTurn) {
                expense = JSON.parse(localStorage.getItem('expenseTurn'));
                if (expense == null) expense = true;
            }
            if(modal === 'TF') this.modalTransferInventory = { 'inventory' : [], expense_turn : expense };
            if(modal === 'AD') {
                this.modalAddMasiveStock = { 'inventory' : [], expense_turn : expense, comment : 'Sin definir' };
                if(waste) this.$set(this.modalAddMasiveStock, 'waste', true);
            };
            
            this.$nextTick(() => {this.$refs.CurrentItem.CleanCurrentItem()});
            this.LoadItemsToSelect();
        },
        AssignItemTransfer(item){
            this.$set(this.modalTransferItem, 'toItem', item);
            this.$forceUpdate();
        },
        ResetStock(all){
            this.Loading();
            axios.post(`/inventory/${this.Local.id}/reset${all ? '/all' : ''}`).then( ({data}) => {
                //this.UpdateInventory();
                this.inventory = this.Util.CalculateInventoryComposite(data);
                this.Response(data);
            }).catch(err => {
                this.Response(err);
            });
        },
        OpenModalTransferItem(item, isCompoundTransfer = false){
            this.modalTransferItem = Util.Copy(item);
            let expense = true;
            if (this.canExpenseTurn) {
                expense = JSON.parse(localStorage.getItem('expenseTurn'));
                if (expense == null) expense = true;
            }
            if(isCompoundTransfer && !this.modalTransferItem.auto_calculate_quantity) {
                this.$set(this.modalTransferItem, 'isCompoundTransfer', true);
                this.$set(this.modalTransferItem, 'fromSpace', '');
            }
            this.$set(this.modalTransferItem, 'expense_turn', expense);
    
        },
        ExportWaste(){
            this.Loading();
            axios.post(`/inventory/waste/${this.Local.id}/export`, this.rangeWaste, {responseType: 'blob'}).then(res => {
                this.Response(res);
                this.Util.DownloadFile(res, `merma_${Util.Today().date.replace(/\//g, '-')}.xls`);
            }).catch(err => {
                this.Response(err);
            });
        },
        DeleteItemFromModal(index){
            this.$refs.CurrentItem.CleanCurrentItem()
            if(this.modalTransferInventory) this.modalTransferInventory.inventory.splice(index, 1)
            if(this.modalAddMasiveStock) this.modalAddMasiveStock.inventory.splice(index, 1)
        },
        LoadItemsToSelect(){
            if(!this.inventory) return;
            let itemSelect = [];
            for(let itemName in this.inventory){
                let item = this.inventory[itemName];
                if(!this.modalEdit || (item.title != this.modalEdit.title)){
                    itemSelect.push({text: `${item.title} (${item.unit ? item.quantity+' '+item.unit : item.quantity})`, value: {
                        dataitem : item },
                        class : item.quantity <= 0 ? 'error-color' : ''
                    },);
                }
            }
            // this.$refs.CurrentItem.CleanCurrentItem()
            this.itemsToArray = itemSelect;
        },
        OnInventoryTransactionDeleted(transaction) {
            this.history = this.history.map(entry => entry.id === transaction.id ? transaction : entry);
            if(this.modalItem)
            {
                if(this.modalItem.history) this.$set(this.modalItem, 'history', this.modalItem.history.filter(entry => entry.id !== transaction.id));
                if(this.modalItem.history_costs) this.$set(this.modalItem, 'history_costs', this.modalItem.history_costs.filter(entry => entry.id !== transaction.id));
                this.$set(this.modalItem, 'stats', null);
                this.$set(this.modalItem, 'providers', null);
            }
            if(this.tab == 'Merma') 
            {
                let callback = !this.modalItemWaste ? null : () => {
                    let history = this.modalItemWaste.history;
                    this.modalItemWaste = this.itemsWaste.items[this.modalItemWaste.data] ? this.itemsWaste.items[this.modalItemWaste.data] : null;
                    if(history) this.$set(this.modalItemWaste, 'history', history.filter(entry => entry.id !== transaction.id));
                };
                this.SearchItemsWaste(callback);
            }
            if(this.modalItemResumenHistory && this.modalItemResumenHistory.history)
                this.$set(this.modalItemResumenHistory, 'history', this.modalItemResumenHistory.history.filter(entry => entry.id !== transaction.id));
            
            if(this.tab == 'Resumen')
                this.Search();
            
        },
        OnSKU(sku)
        {
            if(document.querySelectorAll('.modal').length) return;
            if(this.tab != 'Actual') return;
            this.Loading();
            axios.get(`/inventory/${this.Local.id}/search/item/sku/${sku}`).then(res => {
                this.Response({});
                if(!res.data.inventory_references || !res.data.inventory_references.length) return this.Toast(`${res.data.title} no tiene referencias de inventario`);
                let inventoryData = [];
                console.log(this.inventory);
                res.data.inventory_references.forEach(inventoryItem => {
                    if(this.inventory[inventoryItem.inventory_item])
                    {
                        inventoryData.push({item: this.inventory[inventoryItem.inventory_item], add: inventoryItem.quantity });
                    }
                });
                if(inventoryData.length == 0) return this.Toast('Inventario no encontrado');
                if(inventoryData.length > 1)
                {
                    this.modalAddMasiveStock = { 'inventory' : inventoryData, hideItemSearch: true };
                    this.$nextTick(() => {
                        this.LoadMassiveStockUnitCost();
                    });
                }
                else
                {
                    this.modalAdd = {item: inventoryData[0].item, add: inventoryData[0].add, unit_cost: inventoryData[0].item.unit_cost? inventoryData[0].item.unit_cost : null, expense_turn: 1};
                    if(inventoryData[0].item.unit_cost) 
                    {
                        this.UnitCostChanged(inventoryData[0].item.unit_cost, this.modalAdd);
                    }
                }
            }).catch(err => {
                this.Toast('No encontrado');
                this.Response({});
            });
        },
        LoadMassiveStockUnitCost()
        {
            for(let i = 0; i < this.modalAddMasiveStock.inventory.length; i++)
            {
                let entry = this.modalAddMasiveStock.inventory[i];
                console.log(entry);
                if(entry.item && entry.item.unit_cost)
                {
                    this.$set(this.modalAddMasiveStock.inventory[i], 'unit_cost', entry.item.unit_cost);
                    this.UnitCostChanged(entry.item.unit_cost, entry);
                }
            }
        },
        CompareAvailableStock(){
            let expense = true;
            if(!this.canExpenseTurn) {
                expense = JSON.parse(localStorage.getItem('expenseTurn'));
                if (expense == null) expense = true;
            }
            this.modalCompareStock = { inventory : Util.Copy(this.inventory), expense_turn : expense };
            this.searchCompareInventory = '';
        },
        UpdateInventoryStock(){
            if(!this.modalCompareStock) return;

            let stockToUpdate = {};
            //Verifica si hay items que tengan new_stock
            Object.values(this.modalCompareStock.inventory).forEach(item => {
                if (!isNaN(item.new_stock) && (item.new_stock === 0 || item.new_stock !== item.quantity)) stockToUpdate[item.title] = item;
            });

            if(!Object.values(stockToUpdate).length) return this.Info("No se han registrado cambios en el stock de inventario.");

            // Solamente hace la peticion si al menos 1 item se le ha ingresado stock
            if(Object.values(stockToUpdate).length){

                let list = '<div>¿Confirma los cambios?</div><br><ul>';
                for (let key in stockToUpdate) {
                    let item = stockToUpdate[key];
                    list += `<li class="ta-left">${item.title} ${item.quantity} ${item.unit} → ${item.new_stock} ${item.unit}</li>`;
                }
                list += '</ul>';
                this.Confirm({
                        title: list,
                        text: 'Aceptar',
                        class: 'selected-color',
                        function: () => {
                            this.Loading();
                            axios.patch(`/inventory/${this.Local.id}/update/stock`, { inventory : stockToUpdate, expense_turn : this.modalCompareStock.expense_turn }).then(res => {
                                this.Response(res);
                                this.modalCompareStock = null;
                                this.inventory = this.Util.CalculateInventoryComposite(res.data.inventory);
                            }).catch(err => {
                                this.Response(err);
                            });
                        }
                });

            }
            
        },
        QuantityModalTransfer(){
            // Muestra la cantidad del "ToItem" en el modal
            // Si es un subitem que tiene "BASE", muestra el total de la BASE del subitem que se quiere transferir
            if(!this.modalTransferItem) return
            let quantity = this.modalTransferItem.toItem.quantity;
            if(!this.modalTransferItem.toItem.auto_calculate_quantity && !this.modalTransferItem.isCompoundTransfer) {
                this.modalTransferItem.toItem.subitems.forEach(subs => {
                    if(subs.title == this.modalTransferItem.title) return quantity = subs.base;
                })
            }
            return quantity;
        },
        GoToSubItemStats(item, subitem){
            this.$set(subitem, 'father', { id: item.id, title: item.title });
            this.$set(subitem, 'isSubItem', true);
            this.modalAdd={item: Util.Copy(subitem), unit_cost: subitem.unit_cost? String(subitem.unit_cost) : null, expense_turn: 1};
        },
        AssignItemTransferFrom(item){
            if(this.modalTransferItem.isCompoundTransfer) {
                this.$set(this.modalTransferItem, 'quantity', item.base);
                this.$set(this.modalTransferItem, 'toSpace', item.base);
            }
            this.$forceUpdate();
        },
        OpenModalAdd(type, item) {

            let expense = true;
            if (this.canExpenseTurn) {
                expense = JSON.parse(localStorage.getItem('expenseTurn'));
                if (expense == null) expense = true;
            }

            const base = {
                item: item,
                unit_cost: item.unit_cost ? String(item.unit_cost) : 0,
                expense_turn: expense,
            };

            if (type === "merma") {
                base.unit_cost = String(item.unit_cost);
                base.waste = true;
                base.comment = 'Sin definir';
            }

            if (type === "discount") {
                base.unit_cost = String(item.unit_cost);
                base.inventory_discount = true;
                base.comment = 'Sin definir';
            }

            this.modalAdd = base;
        },
        UpdateExpenseTurn(obj, val){
            if (!obj) return;
            if (!this.canExpenseTurn) return;
            localStorage.setItem('expenseTurn', !!val);
        }
    },
    computed: {

        inventorySelectItems() {
            var ret = [];
            for(var key in this.inventory)
            {
                var item = this.inventory[key];
                ret.push({
                    text: item.title + (item.unit ? ` (${item.unit})` : ''),
                    value: item.title
                });
            }
            return this.Util.NaturalSort(ret, 'text');
        },
        spaces(){
            var ret = {General: {text: 'General', value: 'General', count: 0}};
            for(var key in this.inventory)
            {
                var space = this.inventory[key].space;
                if(!space) space = 'General';
                if(!ret[space]) ret[space] = {text: space, value: space, count: 0};
                ret[space].count++;
            }
            ret = Object.values(ret);
            ret.forEach(entry => {
                entry.description = `${entry.count} items`;
                //entry.text = `${entry.text} (${entry.count})`;
            });

            return ret;
        },
        spacesTransfer(){
            if(!this.modalTransferItem && !this.modalTransferInventory && !this.modalAddMasiveStock) return;
            let ret = [];

            if(this.modalTransferItem && this.hasAttachedInventoryItems.length) {
                ret.push({text : 'Enlazado a '+ this.modalTransferItem.title, value : `linkedTo${this.modalTransferItem.title}`, count: this.hasAttachedInventoryItems.length, description : this.hasAttachedInventoryItems.length+' items'});
            }

            if (this.localsOptionsTransfer.length && (this.modalTransferInventory ||(this.modalTransferItem && !this.modalTransferItem.isCompoundTransfer))) {
                let canReceive = item => {
                    if (this.Local.type === 'FRANCHISE') return item.type !== 'FRANCHISE';
                    return true;
                };

                ret.push(
                    ...this.localsOptionsTransfer
                    .filter(canReceive)
                    .map(item => ({
                        value: item.id,
                        text: item.name,
                        description: item.type === 'FRANCHISE' ? 'Franquicia' : 'Local'
                    }))
                );
            }

            if(!this.spaces) return;

            if(this.modalTransferItem && this.modalTransferItem.fromItem && this.modalTransferItem.isCompoundTransfer) {
                let item = this.inventory[this.modalTransferItem.fromItem.title];
                this.modalTransferItem.toSpace = item.space;
                ret.push({text : item.space, value : item.space, count: 1, description : ''});
                this.$set(this.modalTransferItem, 'toItem', this.inventory[this.modalTransferItem.fromItem.title]);
                return ret;
            }

            if(this.modalTransferItem) ret = ret.concat(this.spaces.filter(space => space.value !== this.modalTransferItem.space));
            return ret;
        },
        currentInventory() {
            var ret = [];
            for(var key in this.inventory)
            {
                var item = this.inventory[key];
                if(!this.search || this.Util.InString(key, this.search))
                {
                    if(!item.performance) item.performance = 100;

                    if(this.orderSpace){
                        if(item.space == this.orderSpace) ret.push(item);
                    }
                }
            }

            /*
            let inventory = Object.values(this.inventory);
            function getQuantityItemEnable(subitems){
                let countSubItemsEnable = [];
                subitems.forEach( subitem => {
                    let findItem = inventory.find( item => item.title == subitem.title);
                    if(findItem){
                        let inventorySubItemPerformance = (findItem.performance? findItem.performance : 100) / 100;
                        let inventorySubItemQuantity = (parseFloat(findItem.quantity * inventorySubItemPerformance)).toFixed(3);
                        let quantityEnable = (inventorySubItemQuantity / subitem.quantity);
                        countSubItemsEnable.push(parseFloat(quantityEnable));
                    }else{
                        countSubItemsEnable.push(0);
                    }
                });
                return Math.min(...countSubItemsEnable) >= 0? Math.min(...countSubItemsEnable) : null;
            }

            ret.forEach(item => {
                if(item.subitems && item.subitems.length > 0){
                    //Tiene subítems
                    let quantityItemEnable = getQuantityItemEnable(item.subitems);
                    if(quantityItemEnable !== null) item.quantity = quantityItemEnable;
                }
            });
            */

            if(this.orderBy == 'QUANTITY')
            {
                ret.sort((a, b) => {
                    return b.quantity - a.quantity;
                });
            }
            else if(this.orderBy == 'NAME')
            {
                ret = this.Util.NaturalSort(ret, 'title');
            }

            var sections = {};
            var others = {title: 'Otros', items: []};

            ret.forEach(item => {
                var section = item.section ? item.section : 'Otros';

                if(section == 'Otros')
                {
                    others.items.push(item);
                }
                else
                {
                    if(!sections[section]) {
                        sections[section] = {
                            title: section,
                            items: []
                        };
                    }
                    sections[section].items.push(item);
                }
                
            });

            sections = Object.values(sections);
            sections = this.Util.NaturalSort(sections, 'title');
            sections.push(others);

            for(var i = sections.length-1; i >= 0; i--)
            {
                if(!sections[i].items.length) sections.splice(i, 1);
            }

            return sections;
        },
        inventoryTransfer(){
            if(!this.modalTransferItem.toSpace) return;

            let ret = [];
            for(let key in this.inventory){
                let item = this.inventory[key];
                if(!item.performance) item.performance = 100;
                if(item.space == this.modalTransferItem.toSpace) ret.push({text: item.title , value: item});
            }

            const firstRecomendation = ret.find((item) => {
                const title = item.text.toLowerCase();
                return title.includes(this.modalTransferItem.title.toLowerCase());
            });
            
            // Muestra los items del nuevo espacio de enlazos a un subitem
            if(/^linkedTo/.test(this.modalTransferItem.toSpace)) {
                this.hasAttachedInventoryItems.forEach(item => {
                    ret.push({text: item.title , value: item});
                });
            }

            if(!this.modalTransferItem.toItem) this.modalTransferItem.toItem = firstRecomendation? firstRecomendation.value : null;
            return ret;
        },
        sections() {
            var ret = {Otros: {text: 'Otros', value: 'Otros'}};
            for(var key in this.inventory)
            {
                var section = this.inventory[key].section;
                if(!section) section = 'Otros';
                if(!ret[section]) ret[section] = {text: section, value: section};
            }
            return Object.values(ret);
        },
        itemsMenuSelect(){
            if(!this.inventory) return;
            let itemSelect = [];
            for(let itemName in this.inventory){
                let item = this.inventory[itemName];
                let enter = true;
                if(item.auto_calculate_quantity && item.subitems && item.subitems.length && this.modalEdit) {
                    item.subitems.forEach(subitem => {
                        if(subitem.title == this.modalEdit.title) enter = false;
                    })
                }

                if(enter && (!this.modalEdit || (item.title != this.modalEdit.title))){
                    itemSelect.push({text: item.title, value: {
                        title: item.title,
                        unit: item.unit,
                        stock : item.quantity,
                        dataitem : item }
                    },);
                }
            }
            return itemSelect;
        },
        providersItems() {
            if(!this.providers) return null;
            var ret = [{text: 'Sin proveedor', value: null}];
            for(var key in this.providers)
            {
                var name = this.providers[key].name;
                var has_rut = this.providers[key].has_rut;
                ret.push({text: `${name} ${!has_rut? '' : '- '+key}`, value: {rut: key, name: name, has_rut : has_rut}});
            }
            return ret;
        },
        canCreateProvider() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.create_providers);
        },
        canEditProvider() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.edit_providers);
        },
        canCreateInvoices() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.create_inventory_invoices);
        },
        canPayInvoices() {
            return !!(this.Auth.role.indexOf('admin') > -1 || this.Auth.restrictions.pay_pending_inventory_invoices);
        },
        filteredItemResumen(){
            if(!this.searchResumen) return this.stats.items;
            let items = [];

            for(let key in this.stats.items){
                if(this.Util.InString(this.stats.items[key].data, this.searchResumen)) items.push(this.stats.items[key]);
            }
            return items;
        },
        tabCount() {
            return {
                Proveedores: this.providers ? Object.values(this.providers).length : 0
            };
        },
        inventoryAlphabeticalOrder(){
            if(!this.modalCompareStock) return;
            let retTemp = {};
            let copyInventory = this.modalCompareStock.inventory;
            retTemp = copyInventory;
            
            //En el caso que se ingrese busqueda
            if(this.searchCompareInventory.length > 0 || this.searchCompareInventory != ''){
                retTemp = {};
                Object.values(copyInventory).forEach((item, key) => {
                    if (this.Util.InString(item.title, this.searchCompareInventory)) {
                        retTemp[item.title] = item;
                    }
                });
            }
            
            // Ordena alfabéticamente
            let ret = Object.keys(retTemp)
                .sort((a, b) => a.localeCompare(b)) 
                .reduce((acc, key) => {
                    acc[key] = copyInventory[key];
                    return acc;
                }, {});
            return ret
        },
        hasAttachedInventoryItems() {
            // Devuelve los items que tiene enlazado un item de inventario
            if(!this.modalTransferItem) return;
            let items = [];
            for(let key in this.inventory){
                let item = this.inventory[key];
                
                if(item.subitems && item.subitems.length) {                     
                    item.subitems.forEach(subitem => {
                        if(subitem.title == this.modalTransferItem.title) items.push(item);
                    });                

                }
            }
            return items;
        },
        inventoryTransferFrom(){

            let ret = [];

            if(!this.modalTransferItem.isCompoundTransfer) return;

            if(this.modalTransferItem && this.modalTransferItem.isCompoundTransfer){
                this.modalTransferItem.subitems.forEach(subitem => {
                    ret.push({text: subitem.title, value: subitem});
                });
            }
            return ret;
        },
        showInventoryTransferInput() {
            if(this.Local.type == 'FRANCHISE') {
                if((!!this.attachedFranchises || !!this.modalTransferItem.isCompoundTransfer) && typeof this.modalTransferItem.toSpace === 'string') return true;   
            }

            if(this.Local.type == 'LOCAL') {
                if(!!this.modalTransferItem.isCompoundTransfer || typeof this.modalTransferItem.toSpace === 'string') return true;
            }
            return false;
        },
        canExpenseTurn() {
            return this.Turn && (this.Auth.role.indexOf('admin') > -1 || (this.Auth.restrictions && this.Auth.restrictions.enable_expense_turn));
        }
    },
    watch: {
        localFilterItemsWaste(){
            this.SearchItemsWaste()
        },
        'modalAdd.expense_turn'(val) {
            this.UpdateExpenseTurn(this.modalAdd, val)
        },
        'modalTransferItem.expense_turn'(val) {
            this.UpdateExpenseTurn(this.modalTransferItem, val)
        },
        'modalTransferInventory.expense_turn'(val) {
            this.UpdateExpenseTurn(this.modalTransferInventory, val)
        },
        'modalAddMasiveStock.expense_turn'(val) {
            this.UpdateExpenseTurn(this.modalAddMasiveStock, val)
        },
        'modalCompareStock.expense_turn'(val) {
            this.UpdateExpenseTurn(this.modalCompareStock, val)
        }
    },
    beforeDestroy() {
        this.sse.Off('INVENTORY_UPDATED', this.UpdateInventory);
    }
}

</script>

<style>

</style>
